(function() {
  var app = angular.module('priorCore', [
    'priorConfig', 'ngResource', 'ngStorage'
  ]);

  app.config([
    '$httpProvider',
    /** @param {angular.IHttpProvider} $httpProvider */
    function priorCoreConfig($httpProvider) {
      $httpProvider.interceptors.push('AcceptHeaderInterceptor');
      $httpProvider.interceptors.push('AcceptLanguageHeaderInterceptor');
      $httpProvider.interceptors.push('EtagHeaderInterceptor');
      $httpProvider.interceptors.push('RunningRequestCounterInterceptor');
      $httpProvider.interceptors.push('IfNoneMatchHeaderInterceptor');
      $httpProvider.interceptors.push('UserTimezoneInterceptor');
      $httpProvider.interceptors.push('AuthenticationInterceptor');
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  var PHONE_FORMATS = {
    'es-ES': /^[1-9][0-9]{8}$/,
    'es-CO': /^([0-9]{10}|[0-9]{12})$/
  };

  app.directive('priorPhoneFormat', function() {
    return {
      require: 'ngModel',
      link: function(__scope__, __elem__, attributes, controller) {
        var format = attributes.priorPhoneFormat;

        if (format && PHONE_FORMATS[format]) {
          controller.$validators.priorPhoneFormat = function(modelValue, viewValue) {
            if (controller.$isEmpty(modelValue)) {
              // consider empty models to be valid
              return true;
            }

            if (PHONE_FORMATS[format].test(viewValue)) {
              // it is valid
              return true;
            }

            // it is invalid
            return false;
          };
        }
      }
    };
  });
})();

(function() {
  var app = angular.module('priorCore');

  var ZIP_CODE_FORMATS = {
    'es-ES': /^[0-9]{5}$/,
    'es-CO': /^[0-9]{6}$/
  };

  app.directive('priorZipCodeFormat', function() {
    return {
      require: 'ngModel',
      link: function(__scope__, __elem__, attributes, controller) {
        var format = attributes.priorZipCodeFormat;

        if (format && ZIP_CODE_FORMATS[format]) {
          controller.$validators.priorZipCodeFormat = function(modelValue, viewValue) {
            if (controller.$isEmpty(modelValue)) {
              // consider empty models to be valid
              return true;
            }

            if (ZIP_CODE_FORMATS[format].test(viewValue)) {
              // it is valid
              return true;
            }

            // it is invalid
            return false;
          };
        }
      }
    };
  });
})();

var EventEnum = (function() {

  var app = angular.module('priorCore');

  /** @enum {string} */
  var EventEnum = {
    RUNNING_REQUESTS_COUNTER_UPDATED: 'prior:running_requests_counte_updated'
  };

  app.constant('EventEnum', EventEnum);

  return EventEnum;
})();
EventEnum = undefined;

var FacebookLoginErrorEnum = (function() {
  /** @enum {number} */
  var FacebookLoginErrorEnum = {
    MISSING_EMAIL_PERMISSION: 41110
  }

  var app = angular.module('priorCore');
  app.constant('FacebookLoginErrorEnum', FacebookLoginErrorEnum);

  return FacebookLoginErrorEnum;
})();
FacebookLoginErrorEnum = undefined;

(function() {
  var app = angular.module('priorCore');

  app.constant('MangopayCardRegistrationErrorEnum', {
    INVALID_CARD_NUMBER: '105202',
    INVALID_EXPIRY_DATE: '105203',
    INVALID_CVV: '105204',
    WRONG_HOLDER_NAME: '999999'
  });

})();

(function() {
  var app = angular.module('priorCore');

  app.constant('MangopayPreauthErrorEnum', {
    CARD_EXPIRED: '101105',
    CARD_INACTIVE: '101106',
    CARD_NOT_ACTIVE: '101410',
    SECURE_MODE_CANCELED: '999997',
    SECURE_MODE_REQUIRED: '999998',
    SECURE_MODE_NOT_AVAILABLE: '101399',
    SECURE_MODE_EXPIRED: '101304',
    SECURE_MODE_INCOMPATIBLE_CARD: '101303',
    SECURE_MODE_UNENROLLED_CARD: '101302',
    SECURE_MODE_FAILED: '101301',
    TRANSACTION_REFUSED: '101199',
    TRANSACTION_REFUSED_AMOUNT_LIMIT: '101102',
    TRANSACTION_REFUSED_BY_TERMINAL: '101103',
    TRANSACTION_REFUSED_CARD_LIMIT_REACHED: '101104',
    TRANSACTION_REFUSED_DO_NOT_HONOUR: '101101'
  });
})();

var MenuItemType = (function() {
  var client = angular.module('priorCore');

  /** @enum {string} */
  var MenuItemType = {
    COMPOSITE: 'composite',
    CUSTOMIZED: 'customized',
    GENERIC: 'generic',
    NON_STANDALONE: 'non-standalone',
    STANDALONE: 'standalone',
    SPECIFIC: 'specific'
  };

  client.constant('MenuItemType', MenuItemType);

  return MenuItemType;
})();
MenuItemType = undefined;

(function() {
  var app = angular.module('priorCore');

  app.constant('OrderErrorCodeEnum', {
    ORDERING_NOT_ALLOWED: 1,
    DELIVERY_NOT_AVAILABLE: 3
  });
})();

var OrderLocationEnum = (function() {
  /** @enum {number} */
  var OrderLocationEnum = {
    TAKEOUT: 1,
    DINING_IN: 2,
    DELIVERY: 3,
    CORPORATE_DELIVERY: 4
  };

  var app = angular.module('priorCore');
  app.constant('OrderLocationEnum', OrderLocationEnum);

  return OrderLocationEnum;
})();
OrderLocationEnum = undefined;

var OrderStatusEnum = (function() {
  /** @enum {string} */
  var OrderStatusEnum = {
    CREATED: 'created',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    UNCONFIRMED: 'unconfirmed'
  };

  var app = angular.module('priorCore');
  app.constant('OrderStatusEnum', OrderStatusEnum);

  return OrderStatusEnum;
})();
OrderStatusEnum = undefined;

(function() {
  var app = angular.module('priorCore');

  app.constant('PaymentErrorEnum', {
    MISSING_PAYMENT_TYPE: '1',
    INCORRECT_PAYMENT_TYPE: '2'
  });
})();

(function() {

  var app = angular.module('priorCore');

  app.constant('PaymentStatusEnum', {
    CHARGED: 'charged',
    PAID: 'paid',
    PREAUTH: 'preauth',
    REJECTED: 'rejected',
    UNPAID: 'unpaid'
  });

})();

(function() {
  var app = angular.module('priorCore');

  app.constant('PositionErrorEnum', {
    UNKNOWN_ERROR: -1,
    PERMISSION_DENIED: 1,
    POSITION_UNAVAILABLE: 2,
    TIMEOUT: 3
  });
})();

(function() {
  var app = angular.module('priorCore');

  app.constant('RejectReasonEnum', {
    UNKNOWN: 0,
    BUSY: 1,
    MISSING_ITEM: 2
  });
})();

var ResetPasswordResponseCodesEnum = (function() {
  /** @enum {number} */
  var ResetPasswordResponseCodesEnum = {
    EXPIRED_LINK_ERROR: 1,
    INVALID_LINK_ERROR: 2,
    PASSWORD_CONFIRMATION_MISMATCH_ERROR: 4,
    SUCCESS: 0,
    UNKNOWN_ERROR: 3,
    USER_CANCELED: 9999
  };

  var app = angular.module('priorCore');
  app.constant('ResetPasswordResponseCodesEnum', ResetPasswordResponseCodesEnum);

  return ResetPasswordResponseCodesEnum;
})();
ResetPasswordResponseCodesEnum = undefined;

var WhenDayEnum = (function() {
  /** @enum string */
  var WhenDayEnum = {
    TODAY: 'today',
    TOMORROW: 'tomorrow'
  };

  var app = angular.module('priorCore');
  app.constant('WhenDayEnum', WhenDayEnum);

  return WhenDayEnum;
})();
WhenDayEnum = undefined;

(function() {
  var app = angular.module('priorCore');

  app.constant('XPriorHeaderEnum', {
    CLIENT_VERSION: 'X-Prior-Client-Version',
    TIMEZONE_DST: 'X-Prior-Timezone-Dst',
    TIMEZONE_OFFSET: 'X-Prior-Timezone-Offset'
  });
})();

angular.module('ngLocale', [], ['$provide', function($provide) {
  var PLURAL_CATEGORY = {ZERO: 'zero', ONE: 'one', TWO: 'two', FEW: 'few', MANY: 'many', OTHER: 'other'};
  $provide.value('$locale', {
    'DATETIME_FORMATS': {
      'AMPMS': [
        'a. m.',
        'p. m.'
      ],
      'DAY': [
        'domingo',
        'lunes',
        'martes',
        'mi\u00e9rcoles',
        'jueves',
        'viernes',
        's\u00e1bado'
      ],
      'ERANAMES': [
        'antes de Cristo',
        'despu\u00e9s de Cristo'
      ],
      'ERAS': [
        'a. C.',
        'd. C.'
      ],
      'FIRSTDAYOFWEEK': 0,
      'MONTH': [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ],
      'SHORTDAY': [
        'dom.',
        'lun.',
        'mar.',
        'mi\u00e9.',
        'jue.',
        'vie.',
        's\u00e1b.'
      ],
      'SHORTMONTH': [
        'ene.',
        'feb.',
        'mar.',
        'abr.',
        'may.',
        'jun.',
        'jul.',
        'ago.',
        'sept.',
        'oct.',
        'nov.',
        'dic.'
      ],
      'STANDALONEMONTH': [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ],
      'WEEKENDRANGE': [
        5,
        6
      ],
      'fullDate': 'EEEE, d \'de\' MMMM \'de\' y',
      'longDate': 'd \'de\' MMMM \'de\' y',
      'medium': 'd MMM y H:mm:ss',
      'mediumDate': 'd MMM y',
      'mediumTime': 'H:mm:ss',
      'short': 'd/M/yy H:mm',
      'shortDate': 'd/M/yy',
      'shortTime': 'H:mm'
    },
    'NUMBER_FORMATS': {
      'CURRENCY_SYM': '\u20ac',
      'DECIMAL_SEP': ',',
      'GROUP_SEP': '.',
      'PATTERNS': [
        {
          'gSize': 3,
          'lgSize': 3,
          'maxFrac': 3,
          'minFrac': 0,
          'minInt': 1,
          'negPre': '-',
          'negSuf': '',
          'posPre': '',
          'posSuf': ''
        },
        {
          'gSize': 3,
          'lgSize': 3,
          'maxFrac': 2,
          'minFrac': 2,
          'minInt': 1,
          'negPre': '-',
          'negSuf': '\u00a0\u00a4',
          'posPre': '',
          'posSuf': '\u00a0\u00a4'
        }
      ]
    },
    'id': 'es-es',
    'localeID': 'es_ES',
    'pluralCat': function(n, __opt_precision__) {  if (n == 1) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

var BaseException = (function() {

  var app = angular.module('priorCore');

  function BaseException(data) {
    var message = data.message;

    this.getMessage = function() {
      return message;
    };
  }

  BaseException.prototype.toString = function baseExceptionToString() {
    return this.getMessage();
  };

  BaseException.build = function(data) {
    return new BaseException(data);
  };

  app.factory('BaseException', [
    function() {
      return BaseException;
    }
  ]);

  return BaseException;
})();
BaseException = undefined;

(function() {
  var app = angular.module('priorCore');

  app.factory('ImplementationError', [
    'BaseException',
    function(BaseException) {
      function ImplementationError(data) {
        BaseException.apply(this, [data]);
      }

      ImplementationError.prototype = Object.create(BaseException.prototype, {
        constructor: {
          value: ImplementationError,
          enumerable: false
        }
      });

      ImplementationError.build = function(data) {
        return new ImplementationError(data);
      };

      return ImplementationError;
    }
  ]);
})();

var InvalidOrder = (function() {
  var app = angular.module('priorCore');

  /** @param {typeof BaseException} BaseException */
  var InvalidOrderCreator = function(BaseException) {
    function InvalidOrderClass(data) {
      BaseException.apply(this, [data]);
    }

    if (BaseException) {
      InvalidOrderClass.prototype = Object.create(BaseException.prototype, {
        constructor: {
          value: InvalidOrderClass,
          enumerable: false
        }
      });
    }

    InvalidOrderClass.build = function(data) {
      return new InvalidOrderClass(data);
    };

    return InvalidOrderClass;
  }


  app.factory('InvalidOrder', [
    'BaseException',
    InvalidOrderCreator
  ]);

  return InvalidOrderCreator(null);
})();
InvalidOrder = undefined;

(function() {
  var app = angular.module('priorCore');

  app.factory('NotImplemented', [
    'BaseException',
    function(BaseException) {
      function NotImplemented(data) {
        BaseException.apply(this, [data]);
      }

      NotImplemented.prototype = Object.create(BaseException.prototype, {
        constructor: {
          value: NotImplemented,
          enumerable: false
        }
      });

      NotImplemented.build = function(data) {
        return new NotImplemented(data);
      };

      return NotImplemented;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('RuntimeError', [
    'BaseException',
    function(BaseException) {
      function RuntimeError(data) {
        BaseException.apply(this, [data]);
      }

      RuntimeError.prototype = Object.create(BaseException.prototype, {
        constructor: {
          value: RuntimeError,
          enumerable: false
        }
      });

      RuntimeError.build = function(data) {
        return new RuntimeError(data);
      };

      return RuntimeError;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.service('OrderItemMapper', [
    'MenuItemType', 'OrderItemModel',
    function(MenuItemType, OrderItemModel) {
      function OrderItemMapper() {
        var nextId = 1;

        function getNextId() {
          return 'order_item_' + nextId++;
        }

        this.map = function mapOrderItemFromMenuItem(menuItem) {
          return OrderItemModel.build({
            OrderMenuItem: {
              id: getNextId(),
              menu_item_id: menuItem.getId(),
              ean: menuItem.getEan(),
              name: menuItem.getName() +
                (menuItem.getType() === MenuItemType.CUSTOMIZED ?
                  (' (' + menuItem.getDescription() + ')') : ''),
              price: menuItem.getPrice(),
              discount: menuItem.getDiscount(),
              quantity: 1
            }
          });
        };
      }

      return new OrderItemMapper();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.service('OrderMapper', [
    'Order',
    function(Order) {
      function OrderMapper() {
        this.mapFromJson = function mapJsonToOrder(orderJson) {
          return Order.build(orderJson);
        };

        this.mapToJson = function mapOrderToJson(order) {
          return {
            Order: {
              id: order.getId()
            }
          };
        };
      }

      return new OrderMapper();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');
  app.factory('AcceptHeaderInterceptor', [
    'apiVersion',
    /**
     * @param {string} apiVersion
     * @returns {angular.IHttpInterceptor}
     */
    function acceptHeaderInterceptorFactory(apiVersion) {
      return {
        request: function(config) {
          config.headers = config.headers || {};
          config.headers.Accept = 'application/vnd.prior.api+json;version=' + apiVersion;

          return config;
        }
      };
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('AcceptLanguageHeaderInterceptor', [
    'Localization',
    function(Localization) {
      return {
        request: function(config) {
          config.headers = config.headers || {};
          config.headers['Accept-Language'] = Localization.getLanguage();

          return config;
        }
      };
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');
  app.factory('AuthenticationInterceptor', [
    '$injector', '$q', 'apiEndpoint', 'CurrentUser', 'TokenModelBuilder',
    /**
     * @param {angular.auto.IInjectorService} $injector
     * @param {angular.IQService} $q
     * @param {string} apiEndpoint
     * @param {CurrentUser} CurrentUser
     * @param {TokenModelBuilder} tokenModelBuilder
     * @returns {angular.IHttpInterceptor}
     */
    function authenticationInterceptorFactory($injector, $q, apiEndpoint, CurrentUser, tokenModelBuilder) {
      function forceLogout(rejection) {
        if (CurrentUser.isSet()) {
          $injector.get('User').logout({}, {}, function() {
            CurrentUser.clear();
          }, function() {
            CurrentUser.clear();
          });
        }
        var $state = $injector.get('$state');
        $state.go('app.landing', {
          goTo: $state.current.name
        });
        return $q.reject(rejection);
      }

      return {
        request: function(config) {
          config.headers = config.headers || {};
          if (CurrentUser.isSet() && angular.isUndefined(config.headers.Authorization)) {
            config.headers.Authorization = 'Bearer ' + CurrentUser.get().getToken().getValue();
          }

          return config;
        },
        responseError: function(rejection) {
          switch (rejection.status) {
            case 401:
              var $http = $injector.get('$http');
              return $http.post(apiEndpoint + '/auth/refresh', undefined, {
                headers: {
                  Authorization: 'Bearer ' + rejection.data[0].token
                }
              }).then(function(result) {
                var currentUser = CurrentUser.get();
                currentUser.setToken(tokenModelBuilder.build({Token: result.data}));
                CurrentUser.set(currentUser);
                rejection.config.headers.Authorization = 'Bearer ' + CurrentUser.get().getToken().getValue();
                return $http(rejection.config);
              }, function() {
                return forceLogout(rejection);
              });
            case 403:
              var data = rejection.data;
              if (angular.isArray(data)) {
                data = data[0];
              }
              if (!angular.isUndefined(data.code) && data.code === 403) {
                CurrentUser.clear();
              }
              return $q.reject(rejection);
          }

          return $q.reject(rejection);
        }
      };
    }
  ]);
}());

(function() {
  var app = angular.module('priorCore');

  app.factory('EtagHeaderInterceptor', [
    'EtagModel', 'EtagsRepository',
    function(EtagModel, EtagsRepository) {
      return {
        response: function(response) {
          var headers = angular.isUndefined(response) ? [] : response.headers();
          if (!angular.isUndefined(headers.etag)) {
            EtagsRepository.save(EtagModel.build({
              url: response.config.url,
              params: response.config.params,
              etag: headers.etag
            }));
          }

          return response;
        }
      };
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('IfNoneMatchHeaderInterceptor', [
    'EtagModel', 'EtagsRepository',
    function(EtagModel, EtagsRepository) {
      return {
        request: function(config) {
          var etag = EtagModel.build({
            url: config.url,
            params: config.params
          });
          if (EtagsRepository.has(etag.getId())) {
            config.headers = config.headers || {};
            config.headers['If-None-Match'] = EtagsRepository.get(etag.getId()).getEtag();
          }

          return config;
        }
      };
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('RunningRequestCounterInterceptor', [
    '$q', '$rootScope', 'EventEnum',
    function($q, $rootScope, EventEnum) {
      var counter = 0;

      function broadcastCounter() {
        $rootScope.$broadcast(EventEnum.RUNNING_REQUESTS_COUNTER_UPDATED, counter);
      }

      function increaseCounter() {
        counter++;
        broadcastCounter();
      }

      function decreaseCounter() {
        counter--;
        broadcastCounter();
      }

      return {
        request: function(config) {
          increaseCounter();

          return config;
        },
        requestError: function(rejection) {
          increaseCounter();

          return $q.reject(rejection);
        },
        response: function(response) {
          decreaseCounter();

          return response;
        },
        responseError: function(rejection) {
          decreaseCounter();

          return $q.reject(rejection);
        }
      };
    }
  ]);
})();

(function() {

  var app = angular.module('priorCore');

  app.factory('UserTimezoneInterceptor', [
    'Timezone', 'XPriorHeaderEnum',
    function(Timezone, XPriorHeaderEnum) {
      return {
        'request': function(config) {
          config.headers = config.headers || {};
          var timezoneHeaders = {};
          timezoneHeaders[XPriorHeaderEnum.TIMEZONE_OFFSET] = Timezone.offset;
          timezoneHeaders[XPriorHeaderEnum.TIMEZONE_DST] = Timezone.dst ? 1 : 0;
          angular.extend(config.headers, timezoneHeaders);

          return config;
        }
      };
    }
  ]);
}());

var BaseRepository = (function() {
  var app = angular.module('priorCore');

  /**
   * @class
   * @param {array} [initItems]
   * @param {{ [key: string]: number }} [initItemIds]
   */
  function BaseRepository(initItems, initItemIds) {
    var items = initItems || [];
    var itemIds = initItemIds || {};

    /** @param {number} itemId */
    function has(itemId) {
      return !angular.isUndefined(itemIds[itemId]) && !angular.isUndefined(items[itemIds[itemId]]);
    }
    this.has = has;

    function save(newItem) {
      if (has(newItem.getId()))
      {
        items[itemIds[newItem.getId()]] = newItem;
      } else {
        items.push(newItem);
        itemIds[newItem.getId()] = items.length - 1;
      }
    }
    this.save = save;

    function saveAll(newItems) {
      newItems.forEach(function(newItem) {
        save(newItem);
      });
    }
    this.saveAll = saveAll;

    function remove(itemId) {
      items.splice(itemIds[itemId], 1);
      for (var i = itemIds[itemId]; i < items.length; i++) {
        itemIds[items[i].getId()] = i;
      }
      delete itemIds[itemId];
    }
    this.remove = remove;

    this.removeAll = function removeAll() {
      items.splice(0, items.length);
      itemIds = {};
    }

    function get(itemId) {
      return has(itemId) ? items[itemIds[itemId]] : null;
    }
    this.get = get;

    function compliesWithConditions(item, conditions) {
      var complies = true,
          itemValue;
      for (var field in conditions) {
        var value = conditions[field];
        switch (field) {
        case 'categoryId':
          itemValue = item.getCategoryId();
          break;
        case 'isStandalone':
          itemValue = item.isStandalone();
          break;
        case 'itemId':
          itemValue = angular.isUndefined(item.getItemId) ? null : item.getItemId();
          break;
        case 'menuItemId':
          itemValue = item.getMenuItemId();
          break;
        case 'restaurantId':
          itemValue = item.getRestaurantId();
          break;
        case 'orderId':
          itemValue = item.getOrderId();
          break;
        case 'sectionId':
          itemValue = item.getSectionId();
          break;
        case 'type':
          itemValue = item.getType();
          break;
        }

        complies =  complies && (itemValue == value);
        if (!complies) {
          break;
        }
      }
      return complies;
    }

    function query(conditions) {
      return items.filter(function(item) {
        return compliesWithConditions(item, conditions);
      });
    }
    this.query = query;

    function getAll() {
      return items;
    }
    this.getAll = getAll;
  }

  app.factory('BaseRepositoryClass', [
    function() {
      return BaseRepository;
    }
  ]);

  app.service('BaseRepository', [
    'BaseRepositoryClass',
    /** @param {typeof BaseRepository} BaseRepository*/
    function(BaseRepository) {
      return new BaseRepository();
    }
  ]);

  return BaseRepository;
})();
BaseRepository = undefined;

(function() {
  var app = angular.module('priorCore');

  app.factory('CategoriesRepositoryClass', [
    'BaseRepositoryClass',
    function(BaseRepositoryClass) {
      function CategoriesRepositoryClass(initItems, initItemIds) {
        var items = initItems || [],
            itemIds = initItemIds || {};

        BaseRepositoryClass.apply(this, [items, itemIds]);

        this.getForRestaurant = function(restaurantId) {
          return this.query({
            restaurantId: restaurantId
          });
        };
      }

      CategoriesRepositoryClass.prototype = Object.create(BaseRepositoryClass.prototype, {
        constructor: {
          value: CategoriesRepositoryClass,
          enumerable: false
        }
      });

      return CategoriesRepositoryClass;
    }
  ]);

  app.service('CategoriesRepository', [
    'CategoriesRepositoryClass',
    function(CategoriesRepositoryClass) {
      return new CategoriesRepositoryClass();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('EtagsRepositoryClass', [
    'BaseRepositoryClass',
    function(BaseRepositoryClass) {
      function EtagsRepositoryClass(initItems, initItemIds) {
        var items = initItems || [],
            itemIds = initItemIds || {};

        BaseRepositoryClass.apply(this, [items, itemIds]);
      }

      EtagsRepositoryClass.prototype = Object.create(BaseRepositoryClass.prototype, {
        constructor: {
          value: EtagsRepositoryClass,
          enumerable: false
        }
      });
      return EtagsRepositoryClass;
    }
  ]);

  app.service('EtagsRepository', [
    'EtagsRepositoryClass',
    function(EtagsRepositoryClass) {
      return new EtagsRepositoryClass();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('MenuItemsRepositoryClass', [
    'BaseRepositoryClass', 'MenuItemType',
    function(BaseRepositoryClass, MenuItemType) {
      function MenuItemsRepositoryClass(initItems, initItemIds) {
        var items = initItems || [],
            itemIds = initItemIds || {};

        BaseRepositoryClass.apply(this, [items, itemIds]);

        function getStandaloneForRestaurantAndCategory(restaurantId, categoryId) {
          return this.query({
            isStandalone: true,
            restaurantId: restaurantId,
            categoryId: categoryId
          });
        }
        this.getStandaloneForRestaurantAndCategory = getStandaloneForRestaurantAndCategory;

        function getForSection(sectionId) {
          return this.query({
            type: MenuItemType.NON_STANDALONE,
            sectionId: sectionId
          });
        }
        this.getForSection = getForSection;

        function getCustomizedFor(menuItemId) {
          return this.query({
            type: MenuItemType.CUSTOMIZED,
            itemId: menuItemId
          });
        }
        this.getCustomizedFor = getCustomizedFor;

        function getSpecificFor(menuItemId) {
          return this.query({
            type: MenuItemType.SPECIFIC,
            itemId: menuItemId
          });
        }
        this.getSpecificFor = getSpecificFor;
      }

      MenuItemsRepositoryClass.prototype = Object.create(BaseRepositoryClass.prototype, {
        constructor: {
          value: MenuItemsRepositoryClass,
          enumerable: false
        }
      });

      return MenuItemsRepositoryClass;
    }
  ]);

  app.service('MenuItemsRepository', [
    'MenuItemsRepositoryClass',
    function(MenuItemsRepositoryClass) {
      return new MenuItemsRepositoryClass();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('ModalMenuItemsRepositoryClass', [
    'BaseRepositoryClass',
    function(BaseRepositoryClass) {
      function ModalMenuItemsRepositoryClass(initItems, initItemIds) {
        var items = initItems || [];
        var itemIds = initItemIds || {};

        BaseRepositoryClass.apply(this, [items, itemIds]);
      }

      ModalMenuItemsRepositoryClass.prototype = Object.create(BaseRepositoryClass.prototype, {
        constructor: {
          value: ModalMenuItemsRepositoryClass,
          enumerable: false
        }
      });

      return ModalMenuItemsRepositoryClass;
    }
  ]);

  app.service('ModalMenuItemsRepository', [
    'ModalMenuItemsRepositoryClass',
    function(ModalMenuItemsRepositoryClass) {
      return new ModalMenuItemsRepositoryClass();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('OrderItemsRepositoryClass', [
    'BaseRepositoryClass',
    function(BaseRepositoryClass) {
      function OrderItemsRepositoryClass(initItems, initItemIds) {
        var items = initItems,
            itemIds = initItemIds;

        BaseRepositoryClass.apply(this, [items, itemIds]);

        this.getForOrderId = function(orderId) {
          return this.query({
            orderId: orderId
          });
        };
      }

      OrderItemsRepositoryClass.prototype = Object.create(BaseRepositoryClass.prototype, {
        constructor: {
          value: OrderItemsRepositoryClass,
          enumerable: false
        }
      });

      return OrderItemsRepositoryClass;
    }
  ]);

  app.service('OrderItemsRepository', [
    'OrderItemsRepositoryClass',
    function(OrderItemsRepositoryClass) {
      return new OrderItemsRepositoryClass();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('RestaurantsRepositoryClass', [
    'BaseRepositoryClass',
    function(BaseRepositoryClass) {
      function RestaurantsRepositoryClass(initItems, initItemIds) {
        var items = initItems || [];
        var itemIds = initItemIds || {};

        BaseRepositoryClass.apply(this, [items, itemIds]);
      }

      RestaurantsRepositoryClass.prototype = Object.create(BaseRepositoryClass.prototype, {
        constructor: {
          value: RestaurantsRepositoryClass,
          enumerable: false
        }
      });

      return RestaurantsRepositoryClass;
    }
  ]);

  app.service('RestaurantsRepository', [
    'RestaurantsRepositoryClass',
    function(RestaurantsRepositoryClass) {
      return new RestaurantsRepositoryClass();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('RuleSetsRepositoryClass', [
    'BaseRepositoryClass',
    function(BaseRepositoryClass) {
      function RuleSetsRepositoryClass(initItems, initItemIds) {
        var items = initItems || [];
        var itemIds = initItemIds || {};

        BaseRepositoryClass.apply(this, [items, itemIds]);
      }

      RuleSetsRepositoryClass.prototype = Object.create(BaseRepositoryClass.prototype, {
        constructor: {
          value: RuleSetsRepositoryClass,
          enumerable: false
        }
      });

      return RuleSetsRepositoryClass;
    }
  ]);

  app.service('RuleSetsRepository', [
    'RuleSetsRepositoryClass',
    function(RuleSetsRepositoryClass) {
      return new RuleSetsRepositoryClass();
    }
  ]);
})();

/**
 * @typedef CardRegistrationData
 * @prop {string} accessKey
 * @prop {string} id
 * @prop {string} preregistrationData
 * @prop {string} url
 */

/**
 * @typedef ICardResource
 * @prop {IResourceMethod<IResource<CardRegistrationData>>} createRegistrationData
 */

/**
 * @typedef {ICardResource & IResourceClass<IResource<CardModel>>} CardResource
 */
var CardResourceFactory = (function() {
  /**
   * @param {angular.IHttpService} $http
   * @param {angular.resource.IResourceService} $resource
   * @param {CardModelBuilder} cardModelBuilder
   * @param {string} apiEndpoint
   */
  function cardResourceFactory($http, $resource, cardModelBuilder, apiEndpoint) {
    /**
     * @param {{[key: string]: any}} data
     * @param {angular.IHttpHeadersGetter} __headersGetter__
     * @param {number} status
     */
    function processResponseData(data, __headersGetter__, status) {
      if (status === 200 && angular.isObject(data)) {
        var card = cardModelBuilder.build(data);
        return card;
      } else {
        return data;
      }
    }

    /**
     * @param {angular.IHttpResponseTransformer | angular.IHttpResponseTransformer[]} defaults
     * @param {angular.IHttpResponseTransformer} specific
     */
    function getResponseDataProcessors(defaults, specific) {
      var result;
      if (typeof defaults === 'function') {
        result = [defaults].concat(specific);
      } else {
        result = defaults.concat(specific);
      }

      return result;
    }

    /** @type {CardResource} */
    var cardResourceInstance = (
      $resource(
        apiEndpoint + '/cards/:id',
        {
          id: '@id'
        },
        {
          get: {
            method: 'GET',
            transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processResponseData)
          },
          save: {
            method: 'POST',
            transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processResponseData)
          },
          createRegistrationData: {
            method: 'POST',
            url: apiEndpoint + '/cards/createRegistrationData'
          }
        }
      )
    );

    return cardResourceInstance;
  }

  var app = angular.module('priorCore');
  app.factory('Card', [
    '$http', '$resource', 'CardModelBuilder', 'apiEndpoint',
    cardResourceFactory
  ]);

  return cardResourceFactory;
})();
CardResourceFactory = undefined;

(function() {
  var app = angular.module('priorCore');

  app.factory('Category', [
    '$http', '$resource', 'CategoryModel', 'apiEndpoint',
    function($http, $resource, CategoryModel, apiEndpoint) {
      function processResponseData(data, __headersGetter__, __status__) {
        if (angular.isObject(data)) {
          var category = CategoryModel.build(data);
          return category;
        } else {
          return data;
        }
      }

      function getResponseDataProcessors(defaults, specific) {
        return (angular.isArray(defaults) ? defaults : [defaults]).concat(specific);
      }

      var Category = $resource(apiEndpoint + '/categories/:id', {
        id: '@id'
      }, {
        get: {
          method: 'GET',
          transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processResponseData)
        },
        query: {
          method: 'GET',
          transformResponse: getResponseDataProcessors(
            $http.defaults.transformResponse,
            function(data, __headersGetter__, status) {
              if (status === 200 && angular.isArray(data)) {
                var categories = data.map(processResponseData);
                return categories;
              } else {
                return data;
              }
            }
          ),
          isArray: true
        }
      });

      return Category;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('MenuItem', [
    '$http', '$resource', 'CompositeMenuItemModel', 'EditableCompositeMenuItemModel', 'GenericMenuItemModel',
    'NonStandaloneMenuItemModel', 'StandaloneMenuItemModel', 'apiEndpoint',
    function($http, $resource, CompositeMenuItemModel, EditableCompositeMenuItemModel, GenericMenuItemModel,
             NonStandaloneMenuItemModel, StandaloneMenuItemModel, apiEndpoint) {
      function processResponseData(data, __headersGetter__, __status__) {
        if (angular.isObject(data)) {
          var menuItem;
          if (data.MenuItem.composite === true) {
            menuItem = data.MenuItem.editable ?
              EditableCompositeMenuItemModel.build(data) :
              CompositeMenuItemModel.build(data);
          } else if (data.MenuItem.generic === true) {
            menuItem = GenericMenuItemModel.build(data);
          } else if (data.MenuItem.standalone === true) {
            menuItem = StandaloneMenuItemModel.build(data);
          } else {
            menuItem = NonStandaloneMenuItemModel.build(data);
          }
          return menuItem;
        } else {
          return data;
        }
      }

      function getResponseDataProcessors(defaults, specific) {
        return (angular.isArray(defaults) ? defaults : [defaults]).concat(specific);
      }

      var MenuItem = $resource(apiEndpoint + '/menu_items/:id', {
        id: '@id'
      }, {
        get: {
          method: 'GET',
          transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processResponseData)
        },
        query: {
          method: 'GET',
          transformResponse: getResponseDataProcessors(
            $http.defaults.transformResponse,
            function(data, __headersGetter__, status) {
              if (status === 200 && angular.isArray(data)) {
                var menuItems = data.map(processResponseData);
                return menuItems;
              } else {
                return data;
              }
            }
          ),
          isArray: true
        }
      });

      return MenuItem;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('Order', [
    '$http', '$resource', 'OrderItemModel', 'OrderItemsRepository', 'OrderModel', 'RedsysAuthorizationPreparationModel',
    'apiEndpoint',
    function(
      $http, $resource, OrderItemModel, OrderItemsRepository, OrderModel, RedsysAuthorizationPreparationModel,
      apiEndpoint
    ) {
      function buildOrder(data) {
        var order = OrderModel.build(data);

        OrderItemsRepository.getForOrderId(data.Order.id).forEach(function(item) {
          OrderItemsRepository.remove(item.getId());
        });

        data.OrderMenuItem.forEach(function(itemData) {
          OrderItemsRepository.save(OrderItemModel.build({
            OrderMenuItem: itemData
          }));
        });
        return order;
      }

      function processRedsysAuthorizationPreparation(data, __headersGetter__, status) {
        if (status == 200 && angular.isObject(data)) {
          return RedsysAuthorizationPreparationModel.build(data);
        } else {
          return data;
        }
      }

      function processOrderData(data, __headersGetter__, status) {
        if (status === 200 && angular.isObject(data)) {
          return buildOrder(data);
        } else {
          return data;
        }
      }

      function getResponseDataProcessors(defaults, specific) {
        return (angular.isArray(defaults) ? defaults : [defaults]).concat(specific);
      }

      var Order = $resource(apiEndpoint + '/orders/:id', {
        id: '@Order.id'
      }, {
        applyPromos: {
          method: 'POST',
          url: apiEndpoint + '/orders/apply-promos'
        },
        cancelPreauth: {
          method: 'POST',
          url: apiEndpoint + '/orders/:id/cancel-preauth'
        },
        checkDeliveryAddress: {
          method: 'POST',
          url: apiEndpoint + '/orders/check-delivery-address'
        },
        checkPromoCode: {
          method: 'POST',
          url: apiEndpoint + '/orders/check-promo-code'
        },
        confirmPreauth: {
          method: 'POST',
          url: apiEndpoint + '/orders/:id/confirm-preauth'
        },
        get: {
          method: 'GET',
          transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processOrderData)
        },
        getDeliveryCharge: {
          method: 'POST',
          url: apiEndpoint + '/orders/get-delivery-charge'
        },
        prepareRedsysAuthorization: {
          method: 'POST',
          url: apiEndpoint + '/orders/:id/prepareRedsysAuthorization',
          params: { id: '@id' },
          transformResponse: getResponseDataProcessors(
            $http.defaults.transformResponse,
            processRedsysAuthorizationPreparation
          )
        },
        preauth: {
          method: 'POST',
          url: apiEndpoint + '/orders/:id/preauth',
          params: { id: '@id' },
          transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processOrderData)
        },
        query: {
          method: 'GET',
          transformResponse: getResponseDataProcessors(
            $http.defaults.transformResponse,
            function(data, __headersGetter__, status) {
              if (status === 200 && angular.isArray(data)) {
                var orders = [];
                for (var index in data) {
                  var order = buildOrder(data[index]);
                  orders.push(order);
                }
                return orders;
              } else {
                return data;
              }
            }),
          isArray: true
        },
        save: {
          method: 'POST',
          transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processOrderData)
        }
      });

      return Order;
    }
  ]);

})();

(function() {
  var app = angular.module('priorCore');

  app.factory('Restaurant', [
    '$http', '$resource', 'RestaurantModel', 'apiEndpoint',
    function($http, $resource, RestaurantModel, apiEndpoint) {
      function processResponseData(data) {
        if (angular.isObject(data)) {
          var restaurant = RestaurantModel.build(data);
          return restaurant;
        } else {
          return data;
        }
      }

      function getResponseDataProcessors(defaults, specific) {
        return (angular.isArray(defaults) ? defaults : [defaults]).concat(specific);
      }

      var Restaurant = $resource(apiEndpoint + '/restaurants/:id', {
        id: '@id'
      }, {
        get: {
          method: 'GET',
          transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processResponseData)
        },
        query: {
          isArray: true,
          method: 'GET',
          transformResponse: getResponseDataProcessors(
            $http.defaults.transformResponse,
            function(data, __headersGetter__, status) {
              if (status === 200 && angular.isArray(data)) {
                var restaurants = data.map(processResponseData);
                return restaurants;
              } else {
                return data;
              }
            }
          )
        }
      });

      return Restaurant;
    }
  ]);
})();

/**
 * @typedef ResetPasswordResponse
 * @prop {number} code
 * @prop {string} message
 */

/**
 * @typedef IUserResource
 * @prop {IResourceMethod<IResource<UserModel>>} authenticate
 * @prop {IResourceMethod<IResource<{ success: boolean, domains: string[] }>>} emailDomains
 * @prop {IResourceMethod<IResource<void>>} logout
 * @prop {IResourceMethod<IResource<UserModel>>} register
 * @prop {IResourceMethod<IResource<{ success: boolean }>>} requestPasswordReset
 * @prop {IResourceMethod<IResource<void>>} requestVerification
 * @prop {IResourceMethod<IResource<ResetPasswordResponse>>} resetPassword
 * @prop {IResourceMethod<IResource<{ success: boolean }>>} saveName
 */

/**
 * @typedef {IUserResource & IResourceClass<IResource<UserModel>>} UserResource
 */
var UserResourceFactory = (function() {
  var app = angular.module('priorCore');

  /**
   * @param {angular.IHttpService} $http
   * @param {angular.resource.IResourceService} $resource
   * @param {string} apiEndpoint
   * @param {UserModelBuilder} userModelBuilder
   */
  function userResourceFactory($http, $resource, apiEndpoint, userModelBuilder) {
    /**
     * @param {{[key: string]: any}} data
     * @param {angular.IHttpHeadersGetter} __headersGetter__
     * @param {number} status
     */
    function processResponse(data, __headersGetter__, status) {
      if (status === 200 && angular.isObject(data)) {
        var user =  userModelBuilder.build(data);
        return user;
      } else {
        return data;
      }
    }

    /**
     * @param {angular.IHttpResponseTransformer | angular.IHttpResponseTransformer[]} defaults
     * @param {angular.IHttpResponseTransformer} specific
     */
    function getResponseDataProcessors(defaults, specific) {
      var result;
      if (typeof defaults === 'function') {
        result = [defaults].concat(specific);
      } else {
        result = defaults.concat(specific);
      }

      return result;
    }

    /** @type {UserResource} */
    var userResourceInstance = (
      $resource(
        apiEndpoint + '/users/:id',
        {
          id: '@id'
        },
        {
          get: {
            method: 'GET',
            transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processResponse)
          },
          authenticate: {
            method: 'POST',
            url: apiEndpoint + '/auth/login',
            transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processResponse)
          },
          logout: {
            method: 'POST',
            url: apiEndpoint + '/auth/logout'
          },
          register: {
            method: 'POST',
            transformResponse: getResponseDataProcessors($http.defaults.transformResponse, processResponse)
          },
          requestPasswordReset: {
            method: 'POST',
            url: apiEndpoint + '/users/request-password-reset'
          },
          requestVerification: {
            method: 'POST',
            url: apiEndpoint + '/users/:id/request-verification'
          },
          resetPassword: {
            method: 'POST',
            url: apiEndpoint + '/users/reset-password'
          },
          saveName: {
            method: 'POST',
            url: apiEndpoint + '/users/:id/save-name'
          },
          emailDomains: {
            method: 'GET',
            url: apiEndpoint + '/users/email-domains'
          }
        }
      )
    );

    return userResourceInstance;
  };

  app.factory('User', [
    '$http', '$resource', 'apiEndpoint', 'UserModelBuilder',
    userResourceFactory
  ]);

  return userResourceFactory;
})();
UserResourceFactory = undefined;

/**
 * @typedef {angular.resource.IResource<T>} IResource
 * @template T
 */

/**
 * @typedef {angular.resource.IResourceClass<T>} IResourceClass
 * @template T
 */

/**
 * @typedef {angular.resource.IResourceMethod<T>} IResourceMethod
 * @template T
 */

/**
 * @typedef CardModel
 * @prop {() => string} getExpiry
 * @prop {() => string} getId
 * @prop {() => string} getNumber
 */
var CardModelBuilder = (function() {

  var app = angular.module('priorCore');

  function CardModel(data) {
    var id = data.Card.id;
    var expiry = data.Card.expiry;
    var number = data.Card.number;

    this.getId = function() {
      return id;
    };

    this.getExpiry = function() {
      return expiry;
    };

    this.getNumber = function() {
      return number;
    };
  }

  function CardModelBuilder() {
    this.build = function(data) {
      return new CardModel(data);
    };
  }

  app.factory('CardModelBuilder', [
    function() {
      return new CardModelBuilder();
    }
  ]);

  return CardModelBuilder;
})();
CardModelBuilder = undefined;

(function() {
  var app = angular.module('priorCore');

  app.factory('CategoryModel', [
    function() {
      function CategoryModel(data) {
        var id = data.Category.id,
            name = data.Category.name,
            restaurantId = data.Category.restaurant_id;

        this.getId = function() {
          return id;
        };

        this.getName = function() {
          return name;
        };

        this.getRestaurantId = function() {
          return restaurantId;
        };
      }

      CategoryModel.build = function(data) {
        return new CategoryModel(data);
      };

      return CategoryModel;
    }]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('CompositeMenuItemModel', [
    'MenuItemModel', 'MenuItemType', 'MenuItemsRepository',
    function(MenuItemModel, MenuItemType, MenuItemsRepository) {
      function CompositeMenuItemModel(data) {
        var childrenIds = !angular.isArray(data.ChildMenuItem) ? [] : data.ChildMenuItem.reduce(function(ids, child) {
          ids.push(child.id);
          return ids;
        }, []);

        MenuItemModel.apply(this, [data]);

        this.getType = function() {
          return MenuItemType.COMPOSITE;
        };

        function getChildren() {
          return childrenIds.map(function(childId) {
            return MenuItemsRepository.get(childId);
          });
        }
        this.getChildren = getChildren;

        function getChildrenForSection(sectionId) {
          return this.getChildren().filter(function(item) {
            return item.getSectionId() === sectionId;
          });
        }
        this.getChildrenForSection = getChildrenForSection;
      }

      CompositeMenuItemModel.prototype = Object.create(MenuItemModel.prototype, {
        constructor: {
          value: CompositeMenuItemModel,
          enumerable: false
        }
      });

      CompositeMenuItemModel.build = function(data) {
        return new CompositeMenuItemModel(data);
      };

      return CompositeMenuItemModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('CompositeRuleSet', [
    'CompositeRule',
    function(CompositeRule) {
      function CompositeRuleSet(data) {
        var id = data.CompositeRuleSet.id,
            rules = !angular.isUndefined(data.CompositeRuleSet.CompositeRule) ?
              data.CompositeRuleSet.CompositeRule.map(function(compositeRuleData) {
                return CompositeRule.build({
                  CompositeRule: compositeRuleData
                });
              }) : [],
            exceptions = !angular.isUndefined(data.CompositeRuleSet.CompositeRuleException) ?
              data.CompositeRuleSet.CompositeRuleException.map(function(ruleExceptionData) {
                return ruleExceptionData.menu_item_id;
              }) : [];

        this.complies = function(items) {
          var result = rules.reduce(function(prevResult, currentRule) {
            var currentResult = currentRule.complies(items.filter(function(item) {
              return item.getSectionId() === currentRule.getSectionId();
            }));
            return prevResult && currentResult;
          }, true);

          return result;
        };

        this.getExceptions = function() {
          return exceptions;
        };

        this.getId = function() {
          return id;
        };

        this.getRules = function() {
          return rules;
        };
      }

      CompositeRuleSet.build = function(data) {
        return new CompositeRuleSet(data);
      };

      return CompositeRuleSet;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('CompositeRule', [
    function() {
      function CompositeRule(data) {
        var id = data.CompositeRule.id,
            sectionId = data.CompositeRule.composite_section_id,
            minCount = data.CompositeRule.min_count,
            maxCount = data.CompositeRule.max_count;

        this.complies = function(items) {
          return items.length >= minCount && items.length <= maxCount;
        };

        this.getId = function() {
          return id;
        };

        this.getMaxCount = function() {
          return maxCount;
        };

        this.getMinCount = function() {
          return minCount;
        };

        this.getSectionId = function() {
          return sectionId;
        };
      }

      CompositeRule.build = function(data) {
        return new CompositeRule(data);
      };

      return CompositeRule;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('CompositeSectionModel', [
    function() {
      function CompositeSectionModel(data) {
        var id = data.CompositeSection.id,
            name = data.CompositeSection.name;

        function getId() {
          return id;
        }
        this.getId = getId;

        function getName() {
          return name;
        }
        this.getName = getName;
      }

      CompositeSectionModel.build = function(data) {
        return new CompositeSectionModel(data);
      };

      return CompositeSectionModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('CustomizedCompositeMenuItemModel', [
    'EditableCompositeMenuItemModel', 'MenuItemType',
    function(EditableCompositeMenuItemModel, MenuItemType) {
      var nextId = 1,
          usedIds = {};

      function getNextId() {
        var newId = 'customized_' + nextId++;
        while (usedIds[newId]) {
          newId = 'customized_' + nextId++;
        }
        usedIds[newId] = true;

        return newId;
      }

      function CustomizedCompositeMenuItemModel(data) {
        var menuItemId = data.MenuItem.menu_item_id;

        if (data.MenuItem.id) {
          usedIds[data.MenuItem.id] = true;
        } else {
          data.MenuItem.id = getNextId();
        }

        EditableCompositeMenuItemModel.apply(this, [data]);

        function getType() {
          return MenuItemType.CUSTOMIZED;
        }
        this.getType = getType;

        this.getItemId = function() {
          return menuItemId;
        };

        function getDescription() {
          return this.getChildren().reduce(function(names, curr) {
            names.push(curr.getName());
            return names;
          }, []).join(', ');
        }
        this.getDescription = getDescription;

        function calculatePrice() {
          return this.getChildren().reduce(
            function(total, currentChild) {
              return total + (this.payExtraFor(currentChild) ? parseInt(currentChild.getPrice()) : 0);
            }.bind(this),
            parseInt(data.MenuItem.price)
          );
        }
        this.getPrice = function getPrice() {
          return calculatePrice.call(this);
        };
      }

      CustomizedCompositeMenuItemModel.prototype = Object.create(EditableCompositeMenuItemModel.prototype, {
        constructor: {
          value: CustomizedCompositeMenuItemModel,
          enumerable: false
        }
      });

      CustomizedCompositeMenuItemModel.build = function(data) {
        return new CustomizedCompositeMenuItemModel(data);
      };

      return CustomizedCompositeMenuItemModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('EditableCompositeMenuItemModel', [
    'CompositeMenuItemModel', 'CompositeRuleSet', 'CompositeSectionModel',
    'MenuItemsRepository',
    function(
      CompositeMenuItemModel, CompositeRuleSet, CompositeSectionModel,
      MenuItemsRepository
    ) {
      function EditableCompositeMenuItemModel(data) {
        var sections = angular.isUndefined(data.CompositeSection) ? [] :
              data.CompositeSection.map(function(compositeSectionData) {
                return CompositeSectionModel.build({
                  CompositeSection: compositeSectionData
                });
              }),
            ruleSets = !angular.isUndefined(data.CompositeRuleSet) ?
              data.CompositeRuleSet.map(function(compositeRuleSetData) {
                return CompositeRuleSet.build({
                  CompositeRuleSet: compositeRuleSetData
                });
              }) : [];

        CompositeMenuItemModel.apply(this, [data]);

        function getCustomizedItems() {
          return MenuItemsRepository.getCustomizedFor(data.MenuItem.id);
        }
        this.getCustomizedItems = getCustomizedItems;

        function getSections() {
          return sections;
        }
        this.getSections = getSections;

        function isSelectionValid(selectedChildren) {
          var result = true;
          if (ruleSets.length > 0) {
            var invalidRuleSets = getInvalidRules(selectedChildren);
            result = (ruleSets.length - invalidRuleSets.length) === 1;
          }

          return result;
        }
        this.isSelectionValid = isSelectionValid;

        function getInvalidRules(selectedChildren) {
          return ruleSets.reduce(function(prevResult, currentRuleSet) {
            var complies = currentRuleSet.complies(selectedChildren);
            if (!complies) {
              prevResult.push({
                rules: currentRuleSet.getRules().map(function(rule) {
                  return {
                    maxCount: rule.getMaxCount(),
                    minCount: rule.getMinCount(),
                    sectionId: rule.getSectionId(),
                    sectionName: sections.filter(function(section) {
                      return section.getId() === rule.getSectionId();
                    })[0].getName()
                  };
                })
              });
            }

            return prevResult;
          }, []);
        }
        this.getInvalidRules = getInvalidRules;

        function payExtraFor(child) {
          return ruleSets.reduce(function(prevResult, currentRuleSet) {
            return prevResult || currentRuleSet.getExceptions().indexOf(child.getId()) !== -1;
          }, false);
        }
        this.payExtraFor = payExtraFor;
      }

      EditableCompositeMenuItemModel.prototype = Object.create(CompositeMenuItemModel.prototype, {
        constructor: {
          value: EditableCompositeMenuItemModel,
          enumerable: false
        }
      });

      EditableCompositeMenuItemModel.build = function(data) {
        return new EditableCompositeMenuItemModel(data);
      };

      return EditableCompositeMenuItemModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('EtagModel', [
    function() {
      function EtagModel(data) {
        var url = data.url,
            params = angular.isUndefined(data.params) ? [] : data.params,
            etag = data.etag;

        this.getId = function() {
          return url + angular.toJson(params);
        };

        this.getUrl = function() {
          return url;
        };

        this.getEtag = function() {
          return etag;
        };
      }

      EtagModel.build = function(data) {
        return new EtagModel(data);
      };

      return EtagModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('GenericMenuItemModel', [
    'MenuItemModel', 'MenuItemType', 'MenuItemsRepository',
    function(MenuItemModel, MenuItemType, MenuItemsRepository) {
      function GenericMenuItemModel(data) {
        var childrenIds = data.SpecificMenuItem.reduce(function(ids, child) {
          ids.push(child.id);
          return ids;
        }, []);

        MenuItemModel.apply(this, [data]);

        this.getType = function() {
          return MenuItemType.GENERIC;
        };

        function getChildren() {
          return childrenIds.map(function(childId) {
            return MenuItemsRepository.get(childId);
          });
        }
        this.getChildren = getChildren;

        function getSpecificItems() {
          return MenuItemsRepository.getSpecificFor(this.getId());
        }
        this.getSpecificItems = getSpecificItems;
      }

      GenericMenuItemModel.prototype = Object.create(MenuItemModel.prototype, {
        constructor: {
          value: GenericMenuItemModel,
          enumerable: true
        }
      });

      GenericMenuItemModel.build = function(data) {
        return new GenericMenuItemModel(data);
      };

      return GenericMenuItemModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('MenuItemImageModel', [
    function() {
      function MenuItemImageModel(data) {
        var active = data.MenuItemImage.active,
            main = data.MenuItemImage.main,
            name = data.MenuItemImage.name,
            path = data.MenuItemImage.path;

        this.isActive = function isActive() {
          return active;
        };

        this.isMain = function isMain() {
          return main;
        };

        this.getName = function getName() {
          return name;
        };

        this.getPath = function getPath() {
          return path;
        };
      }

      MenuItemImageModel.build = function build(data) {
        return new MenuItemImageModel(data);
      };

      return MenuItemImageModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('MenuItemModel', [
    'MenuItemImageModel', 'NotImplemented',
    function(MenuItemImageModel, NotImplemented) {
      function MenuItemModel(data) {
        var id = data.MenuItem.id,
            name = data.MenuItem.name,
            ean = data.MenuItem.ean,
            price = data.MenuItem.price,
            description = data.MenuItem.description,
            categoryId = data.MenuItem.category_id || 0,
            restaurantId = data.MenuItem.restaurant_id,
            standalone = data.MenuItem.standalone,
            editable = data.MenuItem.editable || false,
            discount = (angular.isUndefined(data.MenuItem.discount) || !data.MenuItem.discount) ?
              0 :
              data.MenuItem.discount,
            image = (data.MenuItemImage && data.MenuItemImage[0]) ? MenuItemImageModel.build({
              MenuItemImage: data.MenuItemImage[0]
            }): false;

        this.getDiscount = function() {
          return discount;
        };

        this.getEan = function() {
          return ean;
        };

        this.getId = function() {
          return id;
        };

        function isEditable() {
          return editable;
        }
        this.isEditable = isEditable;

        function getImage() {
          return image;
        }
        this.getImage = getImage;

        this.getName = function() {
          return name;
        };

        this.getPrice = function() {
          return price;
        };

        this.isStandalone = function() {
          return standalone;
        };

        this.getDescription = function() {
          return description;
        };

        this.getType = function() {
          throw NotImplemented.build({message: 'Need to implement getType'});
        };

        this.getCategoryId = function() {
          return categoryId;
        };

        this.getRestaurantId = function() {
          return restaurantId;
        };

        this.getRawData = function() {
          return angular.copy(data);
        };
      }

      MenuItemModel.build = function(data) {
        return new MenuItemModel(data);
      };

      return MenuItemModel;
    }]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('NonStandaloneMenuItemModel', [
    'MenuItemModel', 'MenuItemType',
    function(MenuItemModel, MenuItemType) {
      function NonStandaloneMenuItemModel(data) {
        var sectionId = (angular.isUndefined(data.CompositeSection)  || data.CompositeSection.length === 0) ?
          0 : data.CompositeSection[0].id;
        MenuItemModel.apply(this, [data]);

        this.getSectionId = function() {
          return sectionId;
        };

        this.getType = function() {
          return MenuItemType.NON_STANDALONE;
        };
      }

      NonStandaloneMenuItemModel.prototype = Object.create(MenuItemModel.prototype, {
        constructor: {
          value: NonStandaloneMenuItemModel,
          enumerable: false
        }
      });

      NonStandaloneMenuItemModel.build = function(data) {
        return new NonStandaloneMenuItemModel(data);
      };

      return NonStandaloneMenuItemModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('OrderDeliveryInfoModel', [
    function() {
      function OrderDeliveryInfoModel(data) {
        var id = data.OrderDeliveryInfo.id,
            orderId = data.OrderDeliveryInfo.order_id,
            address = data.OrderDeliveryInfo.address,
            zipCode = data.OrderDeliveryInfo.zip_code,
            city = data.OrderDeliveryInfo.city,
            phone = data.OrderDeliveryInfo.phone;

        function getAddress() {
          return address;
        }

        function getCity() {
          return city;
        }

        function getFullAddress() {
          return address + ', ' + zipCode + ', ' + city;
        }

        function getId() {
          return id;
        }

        function getPhone() {
          return phone;
        }

        function getOrderId() {
          return orderId;
        }

        function getZipCode() {
          return zipCode;
        }

        this.getAddress = getAddress;
        this.getCity = getCity;
        this.getFullAddress = getFullAddress;
        this.getId = getId;
        this.getPhone = getPhone;
        this.getOrderId = getOrderId;
        this.getZipCode = getZipCode;
      }

      OrderDeliveryInfoModel.build = function(data) {
        return new OrderDeliveryInfoModel(data);
      };

      return OrderDeliveryInfoModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('OrderItemModel', [
    function() {
      function OrderItemModel(data) {
        var id = data.OrderMenuItem.id,
            orderId = angular.isUndefined(data.OrderMenuItem.order_id) ? null : data.OrderMenuItem.order_id,
            menuItemId = data.OrderMenuItem.menu_item_id,
            name = data.OrderMenuItem.name,
            ean = data.OrderMenuItem.ean,
            price = data.OrderMenuItem.price,
            discount = (angular.isUndefined(data.OrderMenuItem.discount) || !data.OrderMenuItem.discount) ?
              0 : data.OrderMenuItem.discount,
            quantity = data.OrderMenuItem.quantity;

        this.getDiscount = function() {
          return discount;
        };

        this.setDiscount = function(newDiscount) {
          discount = newDiscount;
        };

        this.getEan = function() {
          return ean;
        };

        this.getId = function() {
          return id;
        };

        this.getMenuItemId = function() {
          return menuItemId;
        };

        this.setOrderId = function(newOrderId) {
          orderId = newOrderId;
        };

        this.getOrderId = function() {
          return orderId;
        };

        this.getName = function() {
          return name;
        };

        this.increaseQuantity = function() {
          quantity++;
        };

        this.decreaseQuantity = function() {
          quantity--;
        };

        this.getQuantity = function() {
          return quantity;
        };

        this.setQuantity = function(newQuantity) {
          quantity = newQuantity;
        };

        this.getPrice = function() {
          return price;
        };

        this.getOriginalTotal = function() {
          return quantity * this.getPrice();
        };

        this.getTotal = function() {
          return quantity * this.getPrice() - this.getDiscount();
        };
      }

      OrderItemModel.build = function(data) {
        return new OrderItemModel(data);
      };

      return OrderItemModel;
    }
  ]);
})();

(function() {
  'use strict';
  var app = angular.module('priorCore');

  app.factory('OrderStatusModel', [
    function() {
      function OrderStatusModel(data) {
        var id = data.OrderStatus.id,
            extra = data.OrderStatus.extra,
            status = data.OrderStatus.status,
            timestamp = data.OrderStatus.timestamp;

        this.getId = function() {
          return id;
        };

        this.getExtra = function() {
          return extra;
        };

        this.getStatus = function() {
          return status;
        };

        this.getTimestamp = function() {
          return timestamp;
        };

        this.getRejectReason = function() {
          var reason = parseInt(extra);

          return reason;
        };
      }

      OrderStatusModel.build = function(data) {
        return new OrderStatusModel(data);
      };

      return OrderStatusModel;
    }
  ]);

})();

(function() {
  var app = angular.module('priorCore');

  app.factory('OrderModel', [
    'OrderDeliveryInfoModel', 'OrderStatusModel',
    function(OrderDeliveryInfoModel, OrderStatusModel) {
      function OrderModel(data) {
        var id = angular.isUndefined(data.Order.id) ? null : data.Order.id,
            currency = data.Order.currency,
            discount = (angular.isUndefined(data.Order.discount) || !data.Order.discount) ? 0 : data.Order.discount,
            paymentType = data.Order.payment_type,
            restaurantId = data.Order.restaurant_id,
            total = data.Order.total,
            status = angular.isUndefined(data.Order.status) ? null : data.Order.status,
            statuses = !angular.isUndefined(data.OrderStatus) ?
              data.OrderStatus.map(function(orderStatusData) {
                return OrderStatusModel.build({
                  OrderStatus: orderStatusData
                });
              }) : [],
            when = data.Order.when,
            where = data.Order.where,
            comments = data.Order.comments,
            deliveryInfo = angular.isUndefined(data.OrderDeliveryInfo) ?
              null : OrderDeliveryInfoModel.build({
                OrderDeliveryInfo: data.OrderDeliveryInfo
              });

        this.getComments = function() {
          return comments;
        };

        this.getCurrency = function() {
          return currency;
        };

        this.getDeliveryInfo = function() {
          return deliveryInfo;
        };

        this.getDiscount = function() {
          return discount;
        };

        this.getId = function() {
          return id;
        };

        this.getPaymentType = function() {
          return paymentType;
        };

        this.getRestaurantId = function() {
          return restaurantId;
        };

        this.getStatuses = function() {
          return statuses;
        };

        this.getStatus = function() {
          return status === null ? (statuses.length > 0 ? statuses[statuses.length - 1].getStatus() : null) : status;
        };

        this.getTotal = function() {
          return total - discount;
        };

        this.getOriginalTotal = function() {
          return total;
        };

        this.getWhen = function() {
          return when;
        };

        this.getWhere = function() {
          return where;
        };
      }

      OrderModel.build = function(data) {
        return new OrderModel(data);
      };

      return OrderModel;
    }
  ]);
})();

(function() {

  var app = angular.module('priorCore');

  app.factory('PaymentProviderModel', [
    function() {
      function PaymentProviderModel(data) {
        var type = data.PaymentProvider.type,
            name = data.PaymentProvider.name,
            isDefault = data.PaymentProvider.RestaurantPaymentProvider.default;

        this.getType = function() {
          return type;
        };

        this.getName = function() {
          return name;
        };

        this.isDefault = function() {
          return isDefault;
        };
      }

      PaymentProviderModel.build = function(data) {
        return new PaymentProviderModel(data);
      };

      return PaymentProviderModel;
    }
  ]);

})();

(function() {

  var app = angular.module('priorCore');

  app.factory('PaymentStatusModel', [
    function() {
      function PaymentStatusModel(data) {
        var id = data.id,
            status = data.status,
            extra = data.extra;

        this.getId = function() {
          return id;
        };

        this.getStatus = function() {
          return status;
        };

        this.getExtra = function() {
          return extra;
        };
      }

      PaymentStatusModel.build = function(data) {
        return new PaymentStatusModel(data);
      };

      return PaymentStatusModel;
    }
  ]);

})();

/* jshint undef: true */
/* globals angular */

(function () {
  'use strict';
  var app = angular.module('priorCore');

  app.factory('RedsysAuthorizationPreparationModel', [
    function() {
      function RedsysAuthorizationPreparationModel(data) {
        var transactionData = data.transactionData,
            signature = data.signature,
            signatureType = data.signatureType,
            url = data.url;

        function getSignature() {
          return signature;
        }

        function getSignatureType() {
          return signatureType;
        }

        function getTransactionData() {
          return transactionData;
        }

        function getUrl() {
          return url;
        }

        this.getSignature = getSignature;
        this.getSignatureType = getSignatureType;
        this.getTransactionData = getTransactionData;
        this.getUrl = getUrl;
      }

      RedsysAuthorizationPreparationModel.build = function(data) {
        return new RedsysAuthorizationPreparationModel(data);
      };

      return RedsysAuthorizationPreparationModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('RestaurantDeliveryOption', [
    'OrderLocationEnum',
    function(OrderLocationEnum) {
      function RestaurantDeliveryOption(data) {
        var name = data.RestaurantDeliveryOption.name,
            type = parseInt(data.RestaurantDeliveryOption.type),
            options = data.RestaurantDeliveryOption.options !== null ?
              JSON.parse(data.RestaurantDeliveryOption.options) : [];

        if (!options.specific) {
          options['specific'] = [];
        }

        function getCoveredZipCodes() {
          return options.specific.reduce(function(zipCodes, option) {
            if (option.zip_codes) {
              zipCodes = zipCodes.concat(option.zip_codes);
            }

            return zipCodes;
          }, []);
        }

        function getOption(optionName, optionDefaultValue) {
          var optionValues = {};
          optionValues[RestaurantDeliveryOption.DEFAULT_OPTION] = options[optionName] === undefined ?
            optionDefaultValue :
            options[optionName];

          return options.specific.reduce(function(optionValues, option) {
            option.zip_codes.forEach(function(zipCode) {
              if (option[optionName] !== undefined) {
                optionValues[zipCode] = option[optionName];
              }
            });

            return optionValues;
          }, optionValues);
        }

        function getDeliveryCharges() {
          return getOption('delivery_charge', 0);
        }

        function getDeliveryChargeMaxOrderValues() {
          return getOption('delivery_charge_max_order_value', Infinity);
        }

        function getMinimumOrders() {
          return getOption('minimum_order', 0);
        }

        function getMinimumPrepTimes() {
          return getOption('minimum_prep_time', 15);
        }

        function getName() {
          return name;
        }

        function getOptions() {
          return options;
        }

        function getType() {
          return type;
        }

        function isDelivery() {
          return type === OrderLocationEnum.DELIVERY;
        }

        this.getCoveredZipCodes = getCoveredZipCodes;
        this.getDeliveryCharges = getDeliveryCharges;
        this.getDeliveryChargeMaxOrderValues = getDeliveryChargeMaxOrderValues;
        this.getMinimumOrders = getMinimumOrders;
        this.getMinimumPrepTimes = getMinimumPrepTimes;
        this.getName = getName;
        this.getOptions = getOptions;
        this.getType = getType;
        this.isDelivery = isDelivery;
      }

      RestaurantDeliveryOption.DEFAULT_OPTION = 'default';

      RestaurantDeliveryOption.build = function(data) {
        return new RestaurantDeliveryOption(data);
      };

      return RestaurantDeliveryOption;
    }
  ]);
})();

(function () {
  var app = angular.module('priorCore');

  app.factory('RestaurantModel', [
    'Localization',
    'PaymentProviderModel',
    'RestaurantDeliveryOption',
    'ScheduleModel',
    function (
      Localization,
      PaymentProviderModel,
      RestaurantDeliveryOption,
      ScheduleModel
    ) {
      function RestaurantModel(data) {
        var id = data.Restaurant.id,
          name = data.Restaurant.name,
          location = data.Restaurant.location,
          distance =
            data.Restaurant.distance < Number.MAX_SAFE_INTEGER
              ? data.Restaurant.distance
              : NaN,
          address = data.Restaurant.address,
          city = data.Restaurant.city,
          prepay = data.Restaurant.prepay,
          paymentProviders = angular.isUndefined(data.PaymentProvider)
            ? []
            : data.PaymentProvider.map(function (PaymentProviderData) {
                return PaymentProviderModel.build({
                  PaymentProvider: PaymentProviderData
                });
              }),
          currency = data.Restaurant.currency,
          description = data.Restaurant.description,
          deliveryOptions = angular.isUndefined(data.RestaurantDeliveryOption)
            ? []
            : data.RestaurantDeliveryOption.map(function (option) {
                return RestaurantDeliveryOption.build({
                  RestaurantDeliveryOption: option
                });
              }),
          addressValidation = data.Restaurant.address_validation,
          phone = data.Restaurant.phone,
          active = data.Restaurant.active,
          schedules = angular.isUndefined(data.Schedule)
            ? []
            : data.Schedule.map(function (scheduleData) {
                return ScheduleModel.build({
                  Schedule: scheduleData
                });
              }),
          allowOrder = data.Restaurant.allow_order || false,
          openNow = data.Restaurant.open_now || false,
          logo = angular.isUndefined(data.Logo) ? false : data.Logo.filename,
          promoName =
            !angular.isUndefined(data.Promo) && data.Promo.length > 0
              ? data.Promo[0].name
              : null,
          coveredZipCodes = deliveryOptions.reduce(function (prev, curr) {
            return curr.isDelivery()
              ? prev.concat(curr.getCoveredZipCodes())
              : prev;
          }, []),
          defaultOrderType = parseInt(data.Restaurant.default_order_type),
          hasMenuImages = !!data.Restaurant.menu_images,
          hasNextDayOrder = !!data.Restaurant.next_day_order;

        this.getAddressValidation = function () {
          return addressValidation;
        };

        this.getCurrency = function () {
          return currency;
        };

        this.getDefaultOrderType = function () {
          return deliveryOptions.reduce(function (prev, curr) {
            if (curr.getType() === defaultOrderType) {
              return defaultOrderType;
            } else {
              return prev;
            }
          }, deliveryOptions[0].getType());
        };

        this.getId = function () {
          return id;
        };

        this.getMinimumOrder = function (orderType, zipCode) {
          return deliveryOptions.reduce(function (minimumOrder, curr) {
            if (curr.getType() === orderType) {
              var minimumOrders = curr.getMinimumOrders();
              minimumOrder =
                minimumOrders[zipCode] === undefined
                  ? minimumOrders[RestaurantDeliveryOption.DEFAULT_OPTION]
                  : minimumOrders[zipCode];
            }

            return minimumOrder;
          }, 0);
        };

        this.getMinimumPrepTime = function (orderType, zipCode) {
          return deliveryOptions.reduce(function (minPrepTime, curr) {
            if (curr.getType() === orderType) {
              var minimumPrepTimes = curr.getMinimumPrepTimes();
              minPrepTime =
                minimumPrepTimes[zipCode] === undefined
                  ? minimumPrepTimes[RestaurantDeliveryOption.DEFAULT_OPTION]
                  : minimumPrepTimes[zipCode];
            }

            return minPrepTime;
          }, 15);
        };

        this.getName = function () {
          return name;
        };

        this.getNextStartTime = function () {
          var nextStartTime,
            now = hourMinute(new Date()),
            startTimesOnDay = this.getStartTimesOnDay(new Date());

          nextStartTime = startTimesOnDay.reduce(function (
            nextStartTime,
            startTime
          ) {
            if (!nextStartTime && hourMinute(startTime) > now) {
              nextStartTime = hourMinute(startTime);
            }

            return nextStartTime;
          },
          false);

          return nextStartTime;
        };

        this.getLocation = function () {
          return location;
        };

        this.getDistance = function () {
          return distance;
        };

        this.getCity = function () {
          return city;
        };

        this.getAddress = function () {
          return address;
        };

        this.getDescription = function () {
          return description;
        };

        this.getPaymentProviders = function () {
          return paymentProviders;
        };

        this.getDefaultPaymentType = function () {
          return this.getPaymentProviders().reduce(function (type, curr) {
            return curr.isDefault() ? curr.getType() : type;
          }, '');
        };

        this.getPhone = function () {
          return phone;
        };

        this.getNormalizedPhone = function () {
          return ('' + phone).replace(/\s/g, '');
        };

        this.isActive = function () {
          return active;
        };

        this.getLogo = function () {
          return logo;
        };

        this.getSchedules = function () {
          return schedules;
        };

        this.isOpenNow = function () {
          return openNow;
        };

        this.isOpenTomorrow = function () {
          var tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);

          return this.getOpeningTimesOnDay(tomorrow).length > 0;
        };

        this.isPrepay = function () {
          return prepay;
        };

        this.allowOrder = function () {
          return allowOrder;
        };

        this.getClosingTimesOnDay = function (date) {
          return schedules
            .filter(function (schedule) {
              return isForDay(schedule, date);
            })
            .reduce(
              function (__acc__, curr) {
                return curr.getClosingTimes(date);
              },
              [new Date()]
            );
        };

        this.getEndTimesOnDay = function (date) {
          return schedules
            .filter(function (schedule) {
              return isForDay(schedule, date);
            })
            .reduce(
              function (__acc__, curr) {
                return curr.getEndTimes(date);
              },
              [new Date()]
            );
        };

        this.getOpeningTimesOnDay = function (date) {
          return schedules
            .filter(function (schedule) {
              return isForDay(schedule, date);
            })
            .reduce(
              function (__acc__, curr) {
                return curr.getOpeningTimes(date);
              },
              [new Date()]
            );
        };

        this.getStartTimesOnDay = function (date) {
          return schedules
            .filter(function (schedule) {
              return isForDay(schedule, date);
            })
            .reduce(
              function (__acc__, curr) {
                return curr.getStartTimes(date);
              },
              [new Date()]
            );
        };

        this.getWhereOptions = function () {
          var added = [],
            options = deliveryOptions
              .map(function (curr) {
                var result = null;
                if (added.indexOf(curr.getType()) === -1) {
                  added.push(curr.getType());
                  result = {
                    name: curr.getName(),
                    value: curr.getType()
                  };
                }
                return result;
              })
              .filter(function (opt) {
                return opt;
              });

          return options;
        };

        this.hasMenuImages = function () {
          return hasMenuImages;
        };

        this.hasNextDayOrder = function () {
          return hasNextDayOrder;
        };

        function validZipCode(zipCode) {
          return coveredZipCodes.indexOf(zipCode) !== -1;
        }
        this.validZipCode = validZipCode;

        function getDeliveryCharge(zipCode) {
          return deliveryOptions.reduce(function (deliveryCharge, curr) {
            if (curr.isDelivery()) {
              var deliveryCharges = curr.getDeliveryCharges();
              deliveryCharge =
                deliveryCharges[zipCode] === undefined
                  ? deliveryCharges[RestaurantDeliveryOption.DEFAULT_OPTION]
                  : deliveryCharges[zipCode];
            }

            return deliveryCharge;
          }, 0);
        }
        this.getDeliveryCharge = getDeliveryCharge;

        function getDeliveryChargeMaxOrderValue(zipCode) {
          return deliveryOptions.reduce(function (
            deliveryChargeMaxOrderValue,
            curr
          ) {
            if (curr.isDelivery()) {
              var deliveryChargeMaxOrderValues = curr.getDeliveryChargeMaxOrderValues();
              deliveryChargeMaxOrderValue =
                deliveryChargeMaxOrderValues[zipCode] === undefined
                  ? deliveryChargeMaxOrderValues[
                      RestaurantDeliveryOption.DEFAULT_OPTION
                    ]
                  : deliveryChargeMaxOrderValues[zipCode];
            }

            return deliveryChargeMaxOrderValue;
          },
          Infinity);
        }
        this.getDeliveryChargeMaxOrderValue = getDeliveryChargeMaxOrderValue;

        this.getPromoName = function () {
          return promoName;
        };

        function hourMinute(date) {
          return date
            .toLocaleTimeString('en-us', { hour12: false })
            .replace(/([0-9]+):([0-9]+)(.+)/, '$1:$2');
        }

        function isForDay(schedule, date) {
          return (schedule.getNumericDay() + 1) % 7 === date.getDay();
        }
      }

      RestaurantModel.build = function (data) {
        return new RestaurantModel(data);
      };

      return RestaurantModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('ScheduleModel', [
    function() {
      function ScheduleModel(data) {
        var dayName = data.Schedule.day_name,
            day = parseInt(data.Schedule.day),
            openingTimes = !data.Schedule.opening ? [] : data.Schedule.opening,
            closingTimes = !data.Schedule.closing ? [] : data.Schedule.closing,
            startTimes = !data.Schedule.start ? [] : data.Schedule.start,
            endTimes = !data.Schedule.end ? [] : data.Schedule.end,
            openingHoursText = data.Schedule.opening_hours_text,
            orderingAllowedText = data.Schedule.ordering_allowed_text;

        this.getDay = function() {
          return dayName;
        };

        this.getNumericDay = function() {
          return day;
        };

        this.getOpeningHours = function() {
          return openingHoursText;
        };

        this.getOrderingAllowed = function() {
          return orderingAllowedText;
        };

        this.getClosingTimes = function(date) {
          return closingTimes.reduce(function(times, closingTime, index) {
            var time = getTime(closingTime, date);
            if (closingTime < openingTimes[index]) {
              time.setDate(time.getDate() + 1);
            }

            times.push(time);

            return times;
          }, []);
        };

        this.getOpeningTimes = function(date) {
          return openingTimes.reduce(function(times, openingTime) {
            times.push(getTime(openingTime, date));

            return times;
          }, []);
        };

        this.getEndTimes = function(date) {
          return endTimes.reduce(function(times, endTime, index) {
            var time = getTime(endTime, date);
            if (endTime < startTimes[index]) {
              time.setDate(time.getDate() + 1);
            }

            times.push(time);

            return times;
          }, []);
        };

        this.getStartTimes = function(date) {
          return startTimes.reduce(function(times, startTime) {
            times.push(getTime(startTime, date));

            return times;
          }, []);
        };

        function getTime(seconds, date) {
          var time = new Date(date),
              hour = Math.floor(seconds / 3600),
              minutes = Math.floor((seconds - hour * 3600) / 60);
          time.setHours(hour, minutes, 0);

          return time;
        }
      }

      ScheduleModel.build = function(data) {
        return new ScheduleModel(data);
      };

      return ScheduleModel;
    }]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('SpecificMenuItemModel', [
    'MenuItemModel', 'MenuItemType',
    function(MenuItemModel, MenuItemType) {
      var nextId = 1,
          usedIds = {};

      function getNextId() {
        var newId = 'specific_' + nextId++;
        while (usedIds[newId]) {
          newId = 'specific_' + nextId++;
        }
        usedIds[newId] = true;
        return newId;
      }

      function SpecificMenuItemModel(data) {
        var selectionId = data.MenuItem.menu_item_id,
            menuItemId = data.MenuItem.generic_id;

        if (data.MenuItem.id) {
          usedIds[data.MenuItem.id] = true;
        } else {
          data.MenuItem.id = getNextId();
        }

        MenuItemModel.apply(this, [data]);

        this.getType = function() {
          return MenuItemType.SPECIFIC;
        };

        this.getItemId = function() {
          return menuItemId;
        };

        this.getSelectionId = function() {
          return selectionId;
        };
      }

      SpecificMenuItemModel.prototype = Object.create(MenuItemModel.prototype, {
        constructor: {
          value: SpecificMenuItemModel,
          enumerable: false
        }
      });

      SpecificMenuItemModel.build = function(data) {
        return new SpecificMenuItemModel(data);
      };

      return SpecificMenuItemModel;
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('StandaloneMenuItemModel', [
    'MenuItemModel', 'MenuItemType',
    function(MenuItemModel, MenuItemType) {
      function StandaloneMenuItemModel(data) {
        MenuItemModel.apply(this, [data]);

        this.getType = function() {
          return MenuItemType.STANDALONE;
        };
      }

      StandaloneMenuItemModel.prototype = Object.create(MenuItemModel.prototype, {
        constructor: {
          value: StandaloneMenuItemModel,
          enumerable: false
        }
      });

      StandaloneMenuItemModel.build = function(data) {
        return new StandaloneMenuItemModel(data);
      };

      return StandaloneMenuItemModel;
    }
  ]);
})();

/**
 * @typedef TokenModel
 * @prop {() => string} getValue
 */
var TokenModelBuilder = (function() {

  var app = angular.module('priorCore');

  function TokenModel(data) {
    var value = data.Token.value;

    this.getValue = function() {
      return value;
    };
  }

  function TokenModelBuilder() {
    this.build = function(data) {
      return new TokenModel(data);
    };
  }

  app.factory('TokenModelBuilder', [
    function() {
      return new TokenModelBuilder();
    }
  ]);

  return TokenModelBuilder;
})();
TokenModelBuilder = undefined;

/**
 * @typedef {object} UserModel
 * @prop {() => CardModel} getCard
 * @prop {() => number} getCredit
 * @prop {() => string} getEmail
 * @prop {() => string} getId
 * @prop {() => string} getName
 * @prop {() => TokenModel} getToken
 * @prop {() => boolean} isVerified
 * @prop {(newCard: CardModel) => void} setCard;
 * @prop {(newName: string) => void} setName;
 * @prop {(newToken: TokenModel) => void} setToken
 * @prop {() => object} toObject
 */
var UserModelBuilder = (function() {
  var app = angular.module('priorCore');

  /**
   * @param {{[key: string]: any}} data
   * @param {TokenModel} token
   * @param {CardModel} card
   */
  function UserModel(data, token, card) {
    var id = data.User.id,
        email = data.User.email,
        name = data.User.name,
        verified = data.User.verified,
        credit = parseInt(data.User.credit);

    function getCard() {
      return card;
    }

    function getCredit() {
      return credit;
    }

    function getEmail() {
      return email;
    }

    function getId() {
      return id;
    }

    function getName() {
      return name;
    }

    function getToken() {
      return token;
    }

    function isVerified() {
      return verified;
    }

    /** @param {CardModel} newCard */
    function setCard(newCard) {
      card = newCard;
    }

    /** @param {string} newName */
    function setName(newName)
    {
      name = newName;
    }

    /** @param {TokenModel} newToken */
    function setToken(newToken) {
      token = newToken;
    }

    function toObject() {
      var cardObj, tokenObj;
      if (card) {
        cardObj = {
          id: card.getId(),
          expiry: card.getExpiry(),
          number: card.getNumber()
        };
      }
      if (token) {
        tokenObj = {
          value: token.getValue()
        };
      }
      return {
        User: {
          id: id,
          email: email,
          verified: verified,
          credit: credit,
          name: name
        },
        Card: cardObj,
        Token: tokenObj
      };
    }

    this.getCard = getCard;
    this.getCredit = getCredit;
    this.getEmail = getEmail;
    this.getId = getId;
    this.getName = getName;
    this.getToken = getToken;
    this.isVerified = isVerified;
    this.setCard = setCard;
    this.setName = setName;
    this.setToken = setToken;
    this.toObject = toObject;
  }

  UserModel.prototype.toString = function userToString() {
    return 'UserModel:' + this.getId() + ',' + this.getEmail();
  };

  /**
   * @param {CardModelBuilder} cardModelBuilder
   * @param {TokenModelBuilder} tokenModelBuilder
   */
  function UserModelBuilder(cardModelBuilder, tokenModelBuilder) {
    this.build = function(data) {
      var token = (angular.isUndefined(data.Token) || data.Token.value === null) ?
          null : tokenModelBuilder.build(data),
          card = (angular.isUndefined(data.Card) || data.Card.number === null) ? null : cardModelBuilder.build(data);

      return new UserModel(data, token, card);
    }
  };

  app.factory('UserModelBuilder', [
    'CardModelBuilder', 'TokenModelBuilder',
    /**
     * @param {CardModelBuilder} cardModelBuilder
     * @param {TokenModelBuilder} tokenModelBuilder
     */
    function(cardModelBuilder, tokenModelBuilder) {
      return new UserModelBuilder(cardModelBuilder, tokenModelBuilder);
    }
  ]);

  return UserModelBuilder;
})();
UserModelBuilder = undefined;

var CacheFactory = (function() {
  var app = angular.module('priorCore');

  function Cache(ttl) {
    var defaultTtl = ttl || 300,
        store = {};

    this.clear = function(key) {
      store[key] = undefined;
    };

    this.clearAll = function() {
      for (var key in store) {
        this.clear(key);
      }
    };

    this.get = function(key, defaultValue) {
      var now = new Date(),
          storeValue = store[key],
          value;

      if (storeValue) {
        if (storeValue.expiry > now) {
          value = storeValue.value;
        }
      }

      return value || defaultValue;
    };

    this.put = function(key, value, ttl) {
      var expiry = new Date();

      ttl = ttl || defaultTtl;
      expiry.setSeconds(expiry.getSeconds() + ttl);

      store[key] = {
        value: value,
        expiry: expiry
      };
    };
  }

  function CacheFactory() {
    this.newCache = /** @param {number} ttl */ function(ttl) {
      return new Cache(ttl);
    };
  }

  app.factory('CacheFactory', [
    function() {

      return new CacheFactory();
    }
  ]);

  return CacheFactory;
})();
CacheFactory = undefined;

(function() {
  var app = angular.module('priorCore');

  app.factory('Currency', [
    'Localization', 'currencyFractionDigits', 'currencyMultiplier',
    function(Localization, currencyFractionDigits, currencyMultiplier) {
      function Currency() {
        var currency = 'EUR';

        this.get = function get() {
          return currency;
        };

        this.set = function set(newCurrency) {
          currency = newCurrency;
        };
      }

      Currency.prototype.getMultiplier = function getMultiplier() {
        return currencyMultiplier;
      };

      Currency.prototype.format = function format(number, currency) {
        var oldCurrency;
        if (currency) {
          oldCurrency = this.get();
          this.set(currency);
        }

        var result = (number / this.getMultiplier()).toLocaleString(
          Localization.getLocale(),
          { style: 'currency', currency: this.get(), minimumFractionDigits: currencyFractionDigits }
        );

        if (oldCurrency) {
          this.set(oldCurrency);
        }

        return result;
      };

      return new Currency();
    }
  ]);
})();

var CurrentOrder = (function() {
  var app = angular.module('priorCore');

  /**
   * @param {ng.IQService} $q
   * @param {ng.IWindowService} $window
   * @param {BaseRepository} BaseRepository
   * @param {CacheFactory} CacheFactory
   * @param {CurrentUser} CurrentUser
   * @param {typeof InvalidOrder} InvalidOrder
   * @param {typeof MenuItemType} MenuItemType
   * @param {typeof OrderLocationEnum} OrderLocationEnum
   * @param {typeof OrderStatusEnum} OrderStatusEnum
   * @param {any} moment
   */
  function CurrentOrder(
    $q, $window, BaseRepository, CacheFactory, CurrentUser, InvalidOrder, MenuItemType,
    MenuItemsRepository, Order, OrderLocationEnum, OrderStatusEnum, moment
  ) {
    var DELIVERY_CHARGE_CACHE_KEY = 'delivery_charge',
        DELIVERY_CHARGE_CACHE_TTL = 60, /* 60 seconds */
        address,
        city,
        comments,
        deliveryChargeCache = CacheFactory.newCache(DELIVERY_CHARGE_CACHE_TTL),
        discount = 0,
        id = null,
        items = [],
        itemIds = {},
        status = OrderStatusEnum.CREATED,
        paymentType,
        phone,
        promoCode,
        restaurant,
        where,
        when,
        zipCode;

    BaseRepository.apply(this, [items, itemIds]);

    function applyPromos() {
      var deferred = $q.defer();

      Order.applyPromos(
        {},
        getOrder.call(this)
      ).$promise
        .then(function(order) {
          order.OrderMenuItem.forEach(function(itemData) {
            var menuItem = MenuItemsRepository.get(itemData.menu_item_id),
                menuItems = [];
            if (menuItem.getType() === MenuItemType.GENERIC) {
              if (itemData.specific_item_id) {
                menuItems = [MenuItemsRepository.get(itemData.specific_item_id)];
              } else {
                menuItems = MenuItemsRepository.query({
                  itemId: itemData.menu_item_id
                });
              }
            } else if ((menuItem.getType() === MenuItemType.COMPOSITE &&
                        menuItem.isEditable() === true)) {
              if (itemData.customized_item_id) {
                menuItems = [MenuItemsRepository.get(itemData.customized_item_id)];
              } else {
                menuItems = MenuItemsRepository.query({
                  itemId: itemData.menu_item_id
                });
              }
            } else {
              menuItems = [menuItem];
            }
            menuItems.forEach(function(menuItem) {
              var orderItem = this.query({
                menuItemId: menuItem.getId()
              })[0];
              if (itemData.active) {
                orderItem.setDiscount(
                  (angular.isUndefined(itemData.discount) || !itemData.discount) ? 0 : itemData.discount
                );
                this.save(orderItem);
              } else if (orderItem) {
                this.remove(orderItem.getId());
                MenuItemsRepository.remove(menuItem.getId());
              }
            }.bind(this));
          }.bind(this));

          this.setDiscount(
            angular.isUndefined(order.Order.discount) || !order.Order.discount ? 0 : order.Order.discount
          );

          deferred.resolve();
        }.bind(this))
        .catch(function(error) {
          deferred.reject(error);
        }.bind(this));

      return deferred.promise;
    }

    function cancelPreauth(preauthId) {
      return Order.cancelPreauth(
        { id: getId() },
        { preauthId: preauthId }
      ).$promise;
    }

    function confirmPreauth(preauthId) {
      return Order.confirmPreauth(
        { id: getId() },
        { preauthId: preauthId }
      ).$promise;
    }

    function checkDeliveryAddress() {
      var deferred = $q.defer();

      if (restaurant.validZipCode(this.getZipCode())) {
        Order.checkDeliveryAddress(
          {},
          getOrder.call(this)
        ).$promise
          .then(function(response) {
            deferred.resolve(response);
          })
          .catch(function() {
            deferred.resolve(false);
          });
      } else {
        deferred.resolve(false);
      }

      return deferred.promise;
    }

    function checkPromoCode() {
      return Order.checkPromoCode(
        {},
        getOrder.call(this)
      ).$promise
        .then(function(response) {
          return response.valid;
        });
    }

    function isValid() {
      return items.length > 0 && restaurant.getId() !== null;
    }

    function clear() {
      items.forEach(function(item) {
        var menuItem = MenuItemsRepository.get(item.getMenuItemId());
        if (
          menuItem &&
            (menuItem.getType() === MenuItemType.CUSTOMIZED ||
             menuItem.getType() === MenuItemType.SPECIFIC)
        ) {
          MenuItemsRepository.remove(item.getMenuItemId());
        }
      });
      this.removeAll();
      address = null;
      city = null;
      comments = null;
      discount = 0;
      id = null;
      paymentType = null;
      phone = null;
      promoCode = null;
      restaurant = null;
      status = OrderStatusEnum.CREATED;
      when = null;
      where = null;
      zipCode = null;
    }

    function getId() {
      return id;
    }

    function getOrder() {
      var orderInfo = {
        Order: {
          comments: this.getComments(),
          delivery_charge: deliveryChargeCache.get(DELIVERY_CHARGE_CACHE_KEY, 0),
          discount: this.getDiscount(),
          id: this.getId(),
          no_switch: true,
          payment_type: this.getPaymentType(),
          promo_code: this.getPromoCode(),
          restaurant_id: this.getRestaurantId(),
          total: this.getOriginalTotal(),
          user_id: CurrentUser.get() ? CurrentUser.get().getId() : null,
          when: this.getWhen(),
          where: this.getWhere()
        },
        OrderDeliveryInfo: {
          address: this.getDeliveryAddress(),
          city: this.getCity(),
          phone: this.getPhone(),
          zip_code: this.getZipCode()
        },
        OrderMenuItem: this.getOrderMenuItems()
      };

      if (getWhere() === OrderLocationEnum.DELIVERY) {
        orderInfo.OrderDeliveryInfo = {
          address: getDeliveryAddress(),
          city: getCity(),
          zip_code: getZipCode(),
          phone: getPhone()
        };
      }

      return orderInfo;
    }

    function getRestaurantId() {
      return restaurant ? restaurant.getId() : null;
    }

    function hasItems() {
      return items.length > 0;
    }

    function init(newRestaurant) {
      this.clear();
      restaurant = newRestaurant;
      city = newRestaurant.getCity();
      where = newRestaurant.getDefaultOrderType();
      when = -1;
    }

    function has(menuItemId) {
      return this.query({
        menuItemId: menuItemId
      }).length > 0;
    }

    function get(menuItemId) {
      return this.query({
        menuItemId: menuItemId
      })[0];
    }

    function getItemsDiscount() {
      var discount = 0;
      items.forEach(function(item) {
        discount += item.getDiscount();
      });

      return discount;
    }

    function getItemsOriginalTotal() {
      var total = 0;
      items.forEach(function(item) {
        total += item.getOriginalTotal();
      });

      return total;
    }

    function getItemsTotal() {
      var total = 0;
      items.forEach(function(item) {
        total += item.getTotal();
      });

      return total;
    }

    function getOriginalTotal() {
      var total = deliveryChargeCache.get(DELIVERY_CHARGE_CACHE_KEY, 0);
      total += getItemsOriginalTotal();

      return total;
    }

    function getWhen() {
      return when;
    }

    function getWhere() {
      return where;
    }

    function getTotal() {
      var total = getOriginalTotal.call(this);

      return total - discount - getItemsDiscount();
    }

    function decreaseItemQuantity(itemId) {
      if (has.call(this, itemId)) {
        var orderItem = get.call(this, itemId);
        if (orderItem.getQuantity() === 1) {
          this.remove(orderItem.getId());
        } else {
          orderItem.decreaseQuantity();
        }
      }
    }

    function increaseItemQuantity(itemId) {
      if (has.call(this, itemId)) {
        get.call(this, itemId).increaseQuantity();
      }
    }

    function getCity() {
      return city;
    }

    function getComments() {
      return comments;
    }

    function getDeliveryAddress() {
      return address;
    }

    function getDeliveryCharge() {
      var deliveryCharge = {
        value: 0
      };

      if (getWhere() === OrderLocationEnum.DELIVERY &&
          !!getFullDeliveryAddress()) {
        deliveryCharge.value = deliveryChargeCache.get(DELIVERY_CHARGE_CACHE_KEY);

        if (deliveryCharge.value === undefined) {
          deliveryCharge.value = 0;
          refreshDeliveryCharge.call(this).then(function(updatedDeliveryCharge) {
            deliveryCharge.value = updatedDeliveryCharge;
            deliveryChargeCache.put(DELIVERY_CHARGE_CACHE_KEY, deliveryCharge.value);
          });
        }
      } else {
        deliveryCharge.value = 0;
        deliveryChargeCache.put(DELIVERY_CHARGE_CACHE_KEY, deliveryCharge.value);
      }

      return deliveryCharge;
    }

    function getFullDeliveryAddress() {
      var address = getDeliveryAddress(),
          zipCode = getZipCode();

      if (!!address && !!zipCode) {
        return address + ', ' + zipCode;
      } else {
        return null;
      }
    }

    function getItemQuantity(itemId) {
      return has.call(this, itemId) ? get.call(this, itemId).getQuantity() : 0;
    }

    function getPaymentType() {
      return paymentType;
    }

    function getPhone() {
      return phone;
    }

    function getPromoCode() {
      return promoCode;
    }

    function getStatus() {
      return status;
    }

    function getZipCode() {
      return zipCode;
    }

    function setComments(newComments) {
      comments = newComments;
    }

    function setDeliveryAddress(newAddress) {
      var done = $q.resolve();

      if (address != newAddress) {
        address = newAddress;
        done = refreshDeliveryCharge.call(this);
      }

      return done;
    }

    function setId(newId) {
      id = newId;
    }

    function setPaymentType(newPaymentType) {
      paymentType = newPaymentType;
    }

    function setPhone(newPhone) {
      phone = newPhone;
    }

    function setPromoCode(newPromoCode) {
      promoCode = newPromoCode;
    }

    function setRestaurant(newRestaurant) {
      restaurant = newRestaurant;
    }

    function setStatus(newStatus) {
      status = newStatus;
    }

    function setWhere(newWhere) {
      where = parseInt(newWhere);
    }

    function setWhen(newWhen) {
      when = newWhen;
    }

    function setZipCode(newZipCode) {
      var done = $q.resolve();

      if (zipCode != newZipCode) {
        zipCode = newZipCode;
        done = refreshDeliveryCharge.call(this);
      }

      return done;
    }

    function getOrderMenuItems() {
      return items.map(function(item) {
        var menuItem = MenuItemsRepository.get(item.getMenuItemId());
        return menuItem ? {
          customized_item_id: menuItem.getType() === MenuItemType.CUSTOMIZED ? item.getMenuItemId() : undefined,
          specific_item_id: menuItem.getType() === MenuItemType.SPECIFIC ? item.getMenuItemId(): undefined,
          menu_item_id: menuItem.getType() === MenuItemType.CUSTOMIZED ||
            menuItem.getType() === MenuItemType.SPECIFIC ? menuItem.getItemId() : menuItem.getId(),
          name: item.getName(),
          ean: item.getEan(),
          price: item.getPrice(),
          discount: item.getDiscount(),
          quantity: item.getQuantity(),
          OrderMenuItemComposition: getOrderMenuItemCompositions(menuItem),
          OrderMenuItemGeneric: getOrderMenuItemGenerics(menuItem)
        } : undefined;
      }).filter(function(item) {
        return item;
      });
    }

    function getOrderMenuItemCompositions(parentItem) {
      var orderMenuItemComposition = [],
          children = parentItem.getType() === MenuItemType.CUSTOMIZED ? parentItem.getChildren() : [];

      return orderMenuItemComposition.concat(children.map(function(child) {
        return {
          parent_id: parentItem.getItemId(),
          child_id: child.getId()
        };
      }));
    }

    function getOrderMenuItemGenerics(parentItem) {
      return parentItem.getType() === MenuItemType.SPECIFIC ? [
        {
          generic_id: parentItem.getItemId(),
          specific_id: parentItem.getSelectionId()
        }
      ] : [];
    }

    function saveOrder() {
      if (!isValid()) {
        throw InvalidOrder.build({message: 'Invalid current order'});
      }

      var deferred = $q.defer(),
          forceRefreshDeliveryCharge = function() {
            return (getWhere() === OrderLocationEnum.DELIVERY) ?
              refreshDeliveryCharge.call(this) :
              $q.resolve(); // Nothing to refresh for non-delivery orders
          };

      forceRefreshDeliveryCharge.call(this)
        .then(applyPromos.bind(this))
        .then(function() {
          var orderInfo = getOrder.call(this);

          return Order.save(
            {},
            orderInfo
          ).$promise
            .then(function(order) {
              this.setId(order.getId());
              this.setStatus(order.getStatus());
              deferred.resolve();

              return true;
            }.bind(this));
        }.bind(this))
        .catch(function(response) {
          deferred.reject(response);
        });

      return deferred.promise;
    }

    function getDiscount() {
      return discount;
    }

    function setDiscount(newDiscount) {
      discount = newDiscount;
    }

    function prepareRedsysAuthorization() {
      if (!isValid()) {
        throw InvalidOrder.build({message: 'Missing order'});
      }

      return Order.prepareRedsysAuthorization(
        { id: getId() },
        {}
      ).$promise;
    }

    function preauth() {
      if (!isValid()) {
        throw InvalidOrder.build({message: 'Missing order'});
      }

      return Order.preauth(
        { id: getId() },
        {
          browserInfo: {
            colorDepth: $window.screen.colorDepth == 30 ? 32 : $window.screen.colorDepth,
            javaEnabled: $window.navigator.javaEnabled(),
            language: $window.navigator.language || $window.navigator.userLanguage,
            screenHeight: $window.screen.height,
            screenWidth: $window.screen.width,
            timezoneOffset: (- moment().utcOffset()).toString(),
            userAgent: $window.navigator.userAgent,
          }
        }
      ).$promise;
    }

    function refreshDeliveryCharge() {
      return Order.getDeliveryCharge(
        {},
        getOrder.call(this)
      ).$promise
        .then(function(result) {
          deliveryChargeCache.put(DELIVERY_CHARGE_CACHE_KEY, result.delivery_charge);

          return result.delivery_charge;
        });
    }

    this.applyPromos = applyPromos;
    this.cancelPreauth = cancelPreauth;
    this.checkDeliveryAddress = checkDeliveryAddress;
    this.checkPromoCode = checkPromoCode;
    this.confirmPreauth = confirmPreauth;
    this.clear = clear;
    this.decreaseItemQuantity = decreaseItemQuantity;
    this.getDeliveryCharge = getDeliveryCharge;
    this.getDiscount = getDiscount;
    this.getCity = getCity;
    this.getComments = getComments;
    this.getDeliveryAddress = getDeliveryAddress;
    this.getFullDeliveryAddress = getFullDeliveryAddress;
    this.getId = getId;
    this.getItemQuantity = getItemQuantity;
    this.getItemsDiscount = getItemsDiscount;
    this.getItemsTotal = getItemsTotal;
    this.getOrderMenuItems = getOrderMenuItems;
    this.getOriginalTotal = getOriginalTotal;
    this.getPaymentType = getPaymentType;
    this.getPhone = getPhone;
    this.getPromoCode = getPromoCode;
    this.getRestaurantId = getRestaurantId;
    this.getStatus = getStatus;
    this.getTotal = getTotal;
    this.getWhen = getWhen;
    this.getWhere = getWhere;
    this.getZipCode = getZipCode;
    this.has = has;
    this.hasItems = hasItems;
    this.increaseItemQuantity = increaseItemQuantity;
    this.init = init;
    this.prepareRedsysAuthorization = prepareRedsysAuthorization;
    this.preauth = preauth;
    this.saveOrder = saveOrder;
    this.setComments = setComments;
    this.setDeliveryAddress = setDeliveryAddress;
    this.setDiscount = setDiscount;
    this.setId = setId;
    this.setPaymentType = setPaymentType;
    this.setPhone = setPhone;
    this.setPromoCode = setPromoCode;
    this.setRestaurant = setRestaurant;
    this.setStatus = setStatus;
    this.setWhen = setWhen;
    this.setWhere = setWhere;
    this.setZipCode = setZipCode;
  }

  app.factory('CurrentOrderClass', [
    'BaseRepositoryClass',
    /** @param {typeof BaseRepository} BaseRepositoryClass */
    function(BaseRepositoryClass) {
      CurrentOrder.prototype = Object.create(BaseRepositoryClass.prototype);
      Object.defineProperty(CurrentOrder.prototype, 'constructor', {
        value: CurrentOrder,
        enumerable: false,
        writable: true
      });

      return CurrentOrder;
    }
  ]);

  app.service('CurrentOrder', [
    '$q', '$window', 'BaseRepositoryClass', 'CurrentOrderClass', 'CacheFactory', 'CurrentUser', 'InvalidOrder', 'MenuItemType',
    'MenuItemsRepository', 'Order', 'OrderLocationEnum', 'OrderStatusEnum', 'moment',
    /**
     * @param {ng.IQService} $q
     * @param {ng.IWindowService} $window
     * @param {typeof BaseRepository} BaseRepository
     * @param {typeof CurrentOrder} CurrentOrder
     * @param {CacheFactory} CacheFactory
     * @param {CurrentUser} CurrentUser
     * @param {typeof InvalidOrder} InvalidOrder
     * @param {typeof MenuItemType} MenuItemType
     * @param {typeof OrderLocationEnum} OrderLocationEnum
     * @param {typeof OrderStatusEnum} OrderStatusEnum
     * @param {any} moment
     */
    function(
      $q, $window, BaseRepository, CurrentOrder, CacheFactory, CurrentUser, InvalidOrder, MenuItemType, MenuItemsRepository,
      Order, OrderLocationEnum, OrderStatusEnum, moment
    ) {
      return new CurrentOrder(
        $q, $window, BaseRepository, CacheFactory, CurrentUser, InvalidOrder, MenuItemType,
        MenuItemsRepository, Order, OrderLocationEnum, OrderStatusEnum, moment
      );
    }
  ]);

  return CurrentOrder;
})();
CurrentOrder = undefined;

var CurrentUser = (function() {
  var app = angular.module('priorCore');

  /**
   * @param {import("ngStorage").ngStorage.StorageService} $localStorage
   * @param {UserModelBuilder} userModelBuilder
   */
  function CurrentUser($localStorage, userModelBuilder) {
    function get() {
      /** @type UserModel */
      var user = null;
      if (isSet()) {
        user = userModelBuilder.build($localStorage.currentUser);
      }
      return user;
    }

    /**
     * @param {UserModel} newUser
     */
    function set(newUser) {
      $localStorage.currentUser = newUser.toObject();
    }

    function clear() {
      delete $localStorage.currentUser;
    }

    function isSet() {
      return !angular.isUndefined($localStorage.currentUser) && (typeof $localStorage.currentUser == 'object');
    }

    this.clear = clear;
    this.get = get;
    this.isSet = isSet;
    this.set = set;
  }

  app.factory('CurrentUser', [
    '$localStorage', 'UserModelBuilder',

    /**
     * @param {import("ngStorage").ngStorage.StorageService} $localStorage
     * @param {UserModelBuilder} userModelBuilder
     */
    function($localStorage, userModelBuilder) {
      return new CurrentUser($localStorage, userModelBuilder);
    }
  ]);

  return CurrentUser;
})();
CurrentUser = undefined;

/**
 * @typedef FacebookLoginResponseAuthResponse
 * @prop {boolean} session_key
 * @prop {number} expiresIn
 * @prop {string} accessToken
 * @prop {string} sig
 * @prop {string} userID
 * @prop {string} secret
 */

/**
 * @typedef FacebookLoginResponse
 * @prop {FacebookLoginResponseAuthResponse} authResponse
 * @prop {string} status
 */

/**
 * @typedef CordovaFacebook
 * @prop {(graphPath: string, permissions: string[]) => angular.IPromise<any>} api
 * @prop {(permissions: string[]) => angular.IPromise<boolean>} checkHasCorrectPermissions
 * @prop {() => angular.IPromise<any>} getLoginStatus
 * @prop {(permissions: string[]) => angular.IPromise<FacebookLoginResponse>} login
 * @prop {() => angular.IPromise<any>} logout
 */

var FacebookLogin = (function() {
  /**
   * @param {CordovaFacebook} $cordovaFacebook
   * @param {angular.IRootScopeService} $rootScope
   * @param {angular.IQService} $q
   * @param {CurrentUser} CurrentUser
   * @param {typeof FacebookLoginErrorEnum} FacebookLoginErrorEnum
   * @param {UserResource} User
   */
  function FacebookLogin($cordovaFacebook, $rootScope, $q, CurrentUser, FacebookLoginErrorEnum, User) {
    /** @type {FacebookLoginResponseAuthResponse} */
    var authResponse;
    /** @type {angular.IDeferred<void>} */
    var deferred = null;
    var permissions = ['public_profile', 'email'];
    /** @type {string} */
    var status;

    function getPermission() {
      return permissions;
    }

    function errorCallback(error) {
      if (deferred !== null) {
        deferred.reject(error);
      }
    }

    function isConnected() {
      return status === 'connected';
    }

    /** @param {FacebookLoginResponse} response */
    function statusChangeCallback(response) {
      authResponse = (!angular.isObject(response) || angular.isUndefined(response.authResponse)) ?
        null : response.authResponse;
      status = (!angular.isObject(response) || angular.isUndefined(response.status)) ?
        'not-connected' : response.status;
      if (isConnected() && !CurrentUser.isSet()) {
        authenticate();
      } else if (deferred !== null) {
        deferred.resolve();
      }
    }

    function authenticate() {
      $cordovaFacebook.checkHasCorrectPermissions(['email'])
        .then(function() {
          User.authenticate(
            { fbAccessToken: authResponse.accessToken },
            /** @param {UserModel} user */
            function(user) {
              CurrentUser.set(user);
              if (deferred !== null) {
                deferred.resolve();
              }
              $rootScope.$emit('loginSuccess');
            },
            /** @param {angular.IHttpResponse} data */
            function(data) {
              if (deferred !== null) {
                deferred.reject(data);
              }
            });
        })
        .catch(function(__missingPermissions__) {
          if (deferred !== null) {
            deferred.reject({
              errorCode: FacebookLoginErrorEnum.MISSING_EMAIL_PERMISSION,
              errorMessage: 'Missing email permission'
            });
          }
        });
    }

    this.getLoginStatus = function() {
      $cordovaFacebook.getLoginStatus().then(
        statusChangeCallback.bind(this),
        function() {}
      );
    };

    this.isConnected = isConnected;

    this.login = function() {
      deferred = $q.defer();

      $cordovaFacebook.login(permissions).then(
        statusChangeCallback.bind(this),
        errorCallback.bind(this)
      );

      return deferred.promise;
    };

    this.logout = function() {
      deferred = $q.defer();

      $cordovaFacebook.logout().then(
        statusChangeCallback.bind(this)
      );

      return deferred.promise;
    };

    this.getFriends = function() {
      return $cordovaFacebook.api('me/friends?fields=picture,first_name', getPermission());
    };
  }

  var app = angular.module('priorCore');
  app.service('FacebookLogin', [
    '$cordovaFacebook', '$rootScope', '$q', 'CurrentUser', 'FacebookLoginErrorEnum', 'User',
    FacebookLogin
  ]);

  return FacebookLogin;
})();
FacebookLogin = undefined;

(function() {
  var app = angular.module('priorCore');

  app.factory('Localization', [
    '$localStorage',
    function($localStorage) {
      function Localization() {
        var locale = 'es-ES',
            language = 'es-ES',
            initDone = false;

        if ($localStorage.language && $localStorage.locale) {
          language = $localStorage.language;
          locale = $localStorage.locale;
          initDone = true;
        }

        this.getInitDone = function getInitDone() {
          return initDone;
        };

        this.getLanguage = function getLanguage() {
          return language;
        };

        this.getLocale = function getLocale() {
          return locale;
        };

        this.setInitDone = function setInitDone() {
          initDone = true;
        };

        this.setLanguage = function setLanguage(newLanguage) {
          language = newLanguage;
          this.persist();
        };

        this.setLocale = function setLocale(newLocale) {
          locale = newLocale;
          this.persist();
        };
      }

      Localization.prototype.persist = function persist() {
        $localStorage.language = this.getLanguage();
        $localStorage.locale = this.getLocale();
      };

      return new Localization();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('Location', [
    '$cordovaGeolocation', '$localStorage', '$q', 'PositionErrorEnum',
    function($cordovaGeolocation, $localStorage, $q, PositionErrorEnum) {
      function Location() {
        function enabled() {
          return isSetAndTrue('locationEnabled');
        }

        function askedToEnable() {
          return isSetAndTrue('locationAskedToEnable');
        }

        function isSetAndTrue(keyName) {
          return !angular.isUndefined($localStorage[keyName]) && $localStorage[keyName];
        }

        function get() {
          var deferred = $q.defer();

          if (enabled()) {
            $cordovaGeolocation.getCurrentPosition({
              timeout: 5000,
              maximumAge: 300000,
              enableHighAccuracy: true
            }).then(function(pos) {
              deferred.resolve({
                latitude: pos.coords.latitude,
                longitude: pos.coords.longitude,
                accuracy: pos.coords.accuracy,
                timestamp: pos.timestamp
              });
            }, function(error) {
              var result;
              if (angular.isObject(error)) {
                result = {
                  code: error.code,
                  message: error.message
                };
              } else {
                result = {
                  code: PositionErrorEnum.UNKNOWN_ERROR,
                  message: 'Uknown error'
                };
              }

              if (result.code === PositionErrorEnum.PERMISSION_DENIED) {
                setEnabled(false);
              }

              deferred.reject(result);
            });
          } else {
            deferred.reject({
              code: PositionErrorEnum.PERMISSION_DENIED,
              message: 'Location not enabled'
            });
          }

          return deferred.promise;
        }

        function setEnabled(newEnabled) {
          $localStorage.locationEnabled = newEnabled;
        }

        function setAskedToEnable() {
          $localStorage.locationAskedToEnable = true;
        }

        this.askedToEnable = askedToEnable;
        this.enabled = enabled;
        this.get = get;
        this.setEnabled = setEnabled;
        this.setAskedToEnable = setAskedToEnable;
      }

      return new Location();
    }
  ]);
})();

(function() {
  var app = angular.module('priorCore');

  app.factory('Timezone', [
    function() {
      return {
        offset: 0,
        dst: false,
        getAsOffset: function() {
          var absOffsetInMins = Math.abs(this.offset) / 60,
              minutes = absOffsetInMins % 60,
              hours = (absOffsetInMins - minutes) / 60;

          return (this.offset > 0 ? '+' : '-') + (hours < 10 ? '0' : '') + hours + (minutes < 10 ? '0' : '') + minutes;
        }
      };
    }
  ]);
})();

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    }
  });
}

//# sourceMappingURL=client-core.js.map
